var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-3",
    d: "M77.66,249.59c-95.18,55-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,194.64,77.66,249.59Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-3",
    d: "M311,278.5l-17.15-9.9a4.11,4.11,0,0,0-3.71,0L74.79,392.92a1.13,1.13,0,0,0,0,2.14l17.32,10.08a4.06,4.06,0,0,0,3.7,0l36.44-21.08a15.51,15.51,0,0,0,1.61,1.07l27.9,16.11a26.84,26.84,0,0,0,24.74,0l53.84-31.09c4-2.31,6.29-5.75,6.29-9.44s-2.29-7.14-6.29-9.45L214.61,336.4,311,280.64A1.13,1.13,0,0,0,311,278.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M275.49,440.1c24.2-14,24.2-36.62,0-50.59s-63.43-14-87.63,0-24.2,36.63,0,50.6S251.29,454.07,275.49,440.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M464.49,433.32c20.8-12,20.8-31.49,0-43.51s-54.54-12-75.34,0-20.8,31.49,0,43.5S443.68,445.33,464.49,433.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M129.65,428a7,7,0,0,0-4.14-.71,4.68,4.68,0,0,0-1.64-1.47,11.12,11.12,0,0,0-10.08,0,3.78,3.78,0,0,0-2.06,2.53,15.14,15.14,0,0,0-9.87,1.35A7.5,7.5,0,0,0,100.2,431c-4.45-1.4-10.15-1-13.92,1.15a7.65,7.65,0,0,0-2.71,2.47c-4.12-1.33-9.42-1-12.92,1a8.3,8.3,0,0,0-1.45,1,8.76,8.76,0,0,0-1.34-.93,16.67,16.67,0,0,0-8.39-1.93,7.55,7.55,0,0,0-3.09-3c-4-2.31-10.08-2.67-14.76-1.11a5.77,5.77,0,0,0-2.72-2.92,15.24,15.24,0,0,0-9-1.57,4,4,0,0,0-1.83-1.91,10.85,10.85,0,0,0-9.8,0,5,5,0,0,0-1.31,1.06,7.46,7.46,0,0,0-4.71.69c-1.87,1.08-1.87,2.83,0,3.91a7.52,7.52,0,0,0,6.41.18A9.59,9.59,0,0,0,22,430c-.42,1.73.51,3.54,2.81,4.87a15.69,15.69,0,0,0,10.76,1.28c.17,1.67,1.34,3.31,3.55,4.59a18.35,18.35,0,0,0,10,2A7.74,7.74,0,0,0,51.69,445c3.74,2.16,9.43,2.51,13.8,1a8.36,8.36,0,0,0,7.53,0,3.75,3.75,0,0,0,.62-.43c4,1.1,9,.7,12.29-1.22a7.45,7.45,0,0,0,2.21-1.86c4.55,1.73,10.73,1.44,14.74-.87a7.39,7.39,0,0,0,2.85-2.7,15.22,15.22,0,0,0,9.94-1.34c2.29-1.33,3.2-3.14,2.73-4.86a10.77,10.77,0,0,0,5.09-1,7.11,7.11,0,0,0,6.16-.12C131.41,430.65,131.41,429,129.65,428Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.97,
    cy: 366.36,
    rx: 25.67,
    ry: 11.71,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.35,351l-27.91-16.11c-5.72-3.31-15.37-4.06-21.54-1.69l-16.57,6.38a94.78,94.78,0,0,0-20.58,11.71l-16.86,13.27a8.45,8.45,0,0,0-3.62,6.49v3.85c0,2.57,1.56,5.06,4.58,6.8l27.91,16.11c5.72,3.31,15,3.31,20.74,0l53.85-31.09c2.87-1.66,4.3-3.84,4.28-6V357C242.63,354.78,241.21,352.61,238.35,351Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,374.86c0,2.57,1.56,5.06,4.58,6.8l27.91,16.11a21.21,21.21,0,0,0,10.37,2.48v-4l-42.86-24.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,374.86c0,2.57,1.56,5.06,4.58,6.8l27.91,16.11a21.21,21.21,0,0,0,10.37,2.48v-4l-42.86-24.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9,333.16l-16.57,6.38a94.78,94.78,0,0,0-20.58,11.71l-16.86,13.27c-5.2,4.09-4.76,10.09,1,13.39L163.76,394c5.72,3.31,15,3.31,20.74,0l53.85-31.08c5.72-3.31,5.72-8.67,0-12l-27.91-16.11C204.72,331.54,195.07,330.79,188.9,333.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44,334.85c-5.72-3.31-15.37-4.06-21.54-1.69l-16.57,6.38a94.78,94.78,0,0,0-20.58,11.71l-16.86,13.27a8.45,8.45,0,0,0-3.62,6.49v3.85c0,2.57,1.56,5.06,4.58,6.8l15.55,9v-3.73L226,343.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3,351.79c0-8.22,2.57-34.13,8-40.19L175,309.69c-8.5,9-18.67,30.43-24.82,42.79,0,0,5.07,2.07,11.32,4.65s15,2.59,19.44,0a6,6,0,0,0,3.35-5.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3,351.79c0-8.22,2.57-34.13,8-40.19L175,309.69c-8.5,9-18.67,30.43-24.82,42.79,0,0,5.07,2.07,11.32,4.65s15,2.59,19.44,0a6,6,0,0,0,3.35-5.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,312.18c3.35,1.39,8,1.39,10.42,0s2.4-4.08,0-6l-4.35-3.51a50,50,0,0,0-12.14,7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.59,369a9.84,9.84,0,0,0,8.9-.17L304.62,248.12a10.16,10.16,0,0,0,4.59-8V46.92a9.84,9.84,0,0,0-4.31-7.79,9.84,9.84,0,0,0-8.9.16L86.88,160.05a10.13,10.13,0,0,0-4.6,7.95V361.25A9.85,9.85,0,0,0,86.59,369Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.49,368.87,304.62,248.11a10.12,10.12,0,0,0,4.59-8V46.91c0-2.93-2-4.11-4.59-2.65L95.5,165A10.13,10.13,0,0,0,90.9,173V366.22C90.9,369.15,93,370.33,95.49,368.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9,350.59v15.63c0,2.93,2.06,4.11,4.59,2.65L304.62,248.11a10.12,10.12,0,0,0,4.59-8V224.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,336.06V175a6.25,6.25,0,0,1,2.83-4.89L300.31,54.34c1.56-.9,2.83-.17,2.83,1.63V217a6.25,6.25,0,0,1-2.83,4.89L99.79,337.69C98.23,338.59,97,337.86,97,336.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64,163.47l8.61,5A9.68,9.68,0,0,0,90.89,173V366.22c0,2.67,1.81,4.16,4.59,2.65a9.75,9.75,0,0,1-8.9.17,8.84,8.84,0,0,1-4.31-7.24V168A9.45,9.45,0,0,1,83.64,163.47Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345,55a1.35,1.35,0,0,0-.05-.29.09.09,0,0,0,0-.07,1.15,1.15,0,0,0-.07-.28,2,2,0,0,0-.19-.42,1.63,1.63,0,0,0-.11-.17.35.35,0,0,0-.1-.11.7.7,0,0,0-.21-.21l0,0a1.43,1.43,0,0,0-.27-.15,2.33,2.33,0,0,0-2.18.27L127.94,176.9a7.14,7.14,0,0,0-3.23,5.59V338a2.18,2.18,0,0,0,1.16,1.94l.14.09a1,1,0,0,0,.17.1,1.22,1.22,0,0,0,.27.09,1.52,1.52,0,0,0,.42.06,2.1,2.1,0,0,0,1.07-.31l.08-.05h0l3.08-1.78L341.74,216.5a7.15,7.15,0,0,0,3.24-5.59V55.38C345,55.24,345,55.1,345,55Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.92,53.24a2.33,2.33,0,0,0-2.18.27L127.94,176.9a7.14,7.14,0,0,0-3.23,5.59v10.56l-4.13-2.42V180.15a7.13,7.13,0,0,1,3.22-5.59L337.62,51.18A2.24,2.24,0,0,1,340,51C340.54,51.34,343.23,52.87,343.92,53.24Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,55.35c0-2-1.45-2.86-3.23-1.83L127.94,176.9a7.11,7.11,0,0,0-3.23,5.59v10.57L345,66Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.74,53.51,127.94,176.9a6.62,6.62,0,0,0-2.27,2.39l-4.11-2.37a6.48,6.48,0,0,1,2.25-2.36L337.62,51.18A2.27,2.27,0,0,1,340,51c.58.36,3.26,1.88,3.94,2.25A2.36,2.36,0,0,0,341.74,53.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,190.65v-10.5a6.62,6.62,0,0,1,1-3.23l4.12,2.36a6.56,6.56,0,0,0-1,3.21v10.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51,67.38a4.83,4.83,0,0,0-1.82,3.86c0,1.55.82,2.34,1.82,1.76a4.8,4.8,0,0,0,1.83-3.86C327.34,67.58,326.52,66.8,325.51,67.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.08,63.58a4.83,4.83,0,0,0-1.82,3.86c0,1.55.82,2.34,1.82,1.76a4.8,4.8,0,0,0,1.83-3.86C333.91,63.78,333.09,63,332.08,63.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,59.78a4.83,4.83,0,0,0-1.82,3.86c0,1.55.82,2.34,1.82,1.76a4.8,4.8,0,0,0,1.83-3.86C340.48,60,339.66,59.2,338.65,59.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.87,339.92l-.17-.09-3.41-2a3.43,3.43,0,0,1-1.68-2.5,3.83,3.83,0,0,1,0-.47V190.64l4.12,2.42V338a2.12,2.12,0,0,0,1,1.83l.1.07,0,0Z",
    style: {
      fill: "#37474f",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.21,164.61l45.08-26.08c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-45.08,26.07c-.63.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,189.21,164.61Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,184.5,329,113.66c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91L206.44,187c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,206.44,184.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,194.44l17.08-9.9c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-17.08,9.91c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,206.44,194.44Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,204.39l17.08-9.91c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-17.08,9.9c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,206.44,204.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,136l98.85-57.15c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-98.85,57.15c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,238.74,136Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,266.05l27.48-15.83c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9l-27.48,15.83c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,206.81,266.05Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,247.65l98.85-57.16c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-98.85,57.15c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,238.74,247.65Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,266.05l27.48-15.83c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9l-27.48,15.83c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,206.81,266.05Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,247.65l98.85-57.16c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-98.85,57.15c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,238.74,247.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,215.57l98.85-57.16c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-98.85,57.15c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,238.74,215.57Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,225.51l98.85-57.16c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91L238.74,228c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,238.74,225.51Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,253.81,234.29,238c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91L206.81,256.3c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,206.81,253.81Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.11,221.14l3.41-2c.63-.37,1.14-.11,1.14.58a2.44,2.44,0,0,1-1.14,1.9l-3.41,2c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,229.11,221.14Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,174.58l22.71-13.18c.63-.36,1.14-.1,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-22.71,13.17c-.63.37-1.15.11-1.15-.58A2.45,2.45,0,0,1,189.21,174.58Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,174.58l22.71-13.18c.63-.36,1.14-.1,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-22.71,13.17c-.63.37-1.15.11-1.15-.58A2.45,2.45,0,0,1,189.21,174.58Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,184.5l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91L189.21,187c-.63.36-1.15.1-1.15-.58A2.48,2.48,0,0,1,189.21,184.5Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,184.5l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91L189.21,187c-.63.36-1.15.1-1.15-.58A2.48,2.48,0,0,1,189.21,184.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,194.45l10.63-6.15c.63-.36,1.14-.1,1.14.59a2.47,2.47,0,0,1-1.14,1.9l-10.63,6.14c-.63.37-1.15.11-1.15-.58A2.45,2.45,0,0,1,189.21,194.45Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,194.45l10.63-6.15c.63-.36,1.14-.1,1.14.59a2.47,2.47,0,0,1-1.14,1.9l-10.63,6.14c-.63.37-1.15.11-1.15-.58A2.45,2.45,0,0,1,189.21,194.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,204.39l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-10.63,6.14c-.63.36-1.15.1-1.15-.58A2.48,2.48,0,0,1,189.21,204.39Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,204.39l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-10.63,6.14c-.63.36-1.15.1-1.15-.58A2.48,2.48,0,0,1,189.21,204.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,214.33l10.63-6.14c.63-.36,1.14-.1,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-10.63,6.14c-.63.37-1.15.11-1.15-.58A2.48,2.48,0,0,1,189.21,214.33Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,214.33l10.63-6.14c.63-.36,1.14-.1,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-10.63,6.14c-.63.37-1.15.11-1.15-.58A2.48,2.48,0,0,1,189.21,214.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,275.72,329,204.89c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9L206.44,278.21c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,206.44,275.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,285.67l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.44,2.44,0,0,1-1.14,1.9l-10.63,6.14c-.63.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,189.21,285.67Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,285.67l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.44,2.44,0,0,1-1.14,1.9l-10.63,6.14c-.63.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,189.21,285.67Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,284.93,329,214.1c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9L206.44,287.42c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,206.44,284.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,294.88l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-10.63,6.14c-.63.36-1.15.1-1.15-.59A2.48,2.48,0,0,1,189.21,294.88Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,294.88l10.63-6.14c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91l-10.63,6.14c-.63.36-1.15.1-1.15-.59A2.48,2.48,0,0,1,189.21,294.88Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,158.84,230,151c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-13.62,7.83c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,216.36,158.84Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,158.84,230,151c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-13.62,7.83c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,216.36,158.84Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,206.41,337.6,148.48c.63-.37,1.14-.11,1.14.58A2.47,2.47,0,0,1,337.6,151L237.42,208.9c-.63.36-1.15.1-1.15-.58A2.48,2.48,0,0,1,237.42,206.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,146.36l13.61-7.84c.64-.36,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91L324,148.84c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,324,146.36Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.36,206.86l100.17-57.93c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9L219.36,209.34c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,219.36,206.86Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,174.56l22.7-13.17c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9L206.44,177c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,206.44,174.56Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,174.56l22.7-13.17c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9L206.44,177c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,206.44,174.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,158.82l91.09-52.6c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91L233.59,161.3c-.63.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,233.59,158.82Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,158.82l91.09-52.6c.63-.37,1.14-.11,1.14.58a2.47,2.47,0,0,1-1.14,1.91L233.59,161.3c-.63.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,233.59,158.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.65,172.1l6.25-3.6c.62-.36,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2L172.65,177c-.62.36-1.13.06-1.13-.66v-2.29A2.52,2.52,0,0,1,172.65,172.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,182.14l6.25-3.61c.62-.36,1.13-.06,1.13.66v2.29a2.52,2.52,0,0,1-1.13,2l-6.25,3.6c-.62.37-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,182.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,192.18l6.25-3.61c.62-.36,1.13-.07,1.13.66v2.29a2.52,2.52,0,0,1-1.13,2l-6.25,3.6c-.62.36-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,192.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,202.22l6.25-3.61c.62-.36,1.13-.07,1.13.66v2.29a2.55,2.55,0,0,1-1.13,2l-6.25,3.6c-.62.36-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,202.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,212.25l6.25-3.6c.62-.36,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.61c-.62.36-1.13.07-1.13-.66v-2.29A2.55,2.55,0,0,1,172.65,212.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,222.29l6.25-3.6c.62-.36,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.61c-.62.36-1.13.06-1.13-.66v-2.29A2.52,2.52,0,0,1,172.65,222.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,232.33l6.25-3.6c.62-.37,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.6c-.62.37-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,232.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,242.37l6.25-3.61c.62-.36,1.13-.07,1.13.66v2.29a2.52,2.52,0,0,1-1.13,2l-6.25,3.6c-.62.36-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,242.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,252.41l6.25-3.61c.62-.36,1.13-.07,1.13.66v2.29a2.55,2.55,0,0,1-1.13,2l-6.25,3.6c-.62.36-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,252.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,262.44l6.25-3.6c.62-.36,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.61c-.62.36-1.13.07-1.13-.66v-2.29A2.55,2.55,0,0,1,172.65,262.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,272.48l6.25-3.6c.62-.36,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.61c-.62.36-1.13.06-1.13-.66v-2.29A2.52,2.52,0,0,1,172.65,272.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,282.52l6.25-3.6c.62-.37,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.6c-.62.37-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,282.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,292.27l6.25-3.6c.62-.36,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.61c-.62.36-1.13.06-1.13-.66v-2.29A2.52,2.52,0,0,1,172.65,292.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,302.31l6.25-3.6c.62-.37,1.13-.07,1.13.65v2.3a2.51,2.51,0,0,1-1.13,2l-6.25,3.6c-.62.37-1.13.07-1.13-.65v-2.3A2.51,2.51,0,0,1,172.65,302.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,195.54,165,176c1.25-.72,2.26-.13,2.26,1.31v39a5,5,0,0,1-2.26,3.93l-33.77,19.49c-1.25.73-2.27.14-2.27-1.31v-39A5,5,0,0,1,131.23,195.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,230.56l3.1-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,134.37,230.56Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,230.56l3.1-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,134.37,230.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,198.64l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,134.37,198.64Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,198.64l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,134.37,198.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,202.49l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9L138.73,205c-.63.37-1.14.11-1.14-.58A2.45,2.45,0,0,1,138.73,202.49Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,202.49l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9L138.73,205c-.63.37-1.14.11-1.14-.58A2.45,2.45,0,0,1,138.73,202.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,208.86l3.11-1.8c.64-.36,1.15-.1,1.15.59a2.45,2.45,0,0,1-1.15,1.9l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,138.73,208.86Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,208.86l3.11-1.8c.64-.36,1.15-.1,1.15.59a2.45,2.45,0,0,1-1.15,1.9l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,138.73,208.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,217.79l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-3.1,1.8c-.64.36-1.15.1-1.15-.59A2.45,2.45,0,0,1,134.37,217.79Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,217.79l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-3.1,1.8c-.64.36-1.15.1-1.15-.59A2.45,2.45,0,0,1,134.37,217.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,221.64l3.11-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.47,2.47,0,0,1,138.73,221.64Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,221.64l3.11-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.47,2.47,0,0,1,138.73,221.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,193.73l19-11c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,142.88,193.73Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,193.73l19-11c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,142.88,193.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,225.65l19-11c.63-.36,1.15-.1,1.15.59a2.46,2.46,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,225.65Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,225.65l19-11c.63-.36,1.15-.1,1.15.59a2.46,2.46,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,225.65Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,197.57l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,197.57Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,197.57l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,197.57Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,204l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-14.61,8.43c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,147.25,204Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,204l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-14.61,8.43c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,147.25,204Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,212.88l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.36-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,212.88Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,212.88l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.36-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,212.88Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,216.73l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,216.73Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,216.73l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,216.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,247.1,165,227.6c1.25-.72,2.26-.13,2.26,1.31v77a5,5,0,0,1-2.26,3.93l-33.77,19.49c-1.25.73-2.27.14-2.27-1.31V251A5,5,0,0,1,131.23,247.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,250.2l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,134.37,250.2Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,250.2l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,134.37,250.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,254.05l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.45,2.45,0,0,1,138.73,254.05Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,254.05l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.45,2.45,0,0,1,138.73,254.05Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,260.42l3.11-1.8c.64-.36,1.15-.1,1.15.59a2.45,2.45,0,0,1-1.15,1.9l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.45,2.45,0,0,1,138.73,260.42Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,260.42l3.11-1.8c.64-.36,1.15-.1,1.15.59a2.45,2.45,0,0,1-1.15,1.9l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.45,2.45,0,0,1,138.73,260.42Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,269.35l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-3.1,1.8c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,134.37,269.35Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,269.35l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-3.1,1.8c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,134.37,269.35Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,245.29l19-11c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,142.88,245.29Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,245.29l19-11c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,142.88,245.29Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,249.13l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,249.13Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,249.13l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,249.13Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,255.52l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.48,2.48,0,0,1-1.15,1.91L147.25,258c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,147.25,255.52Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,255.52l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.48,2.48,0,0,1-1.15,1.91L147.25,258c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,147.25,255.52Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,264.44l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,264.44Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,264.44l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,264.44Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,273.24l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.36-1.14.1-1.14-.58A2.47,2.47,0,0,1,138.73,273.24Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,273.24l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.36-1.14.1-1.14-.58A2.47,2.47,0,0,1,138.73,273.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,279.61l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.36-1.14.1-1.14-.58A2.47,2.47,0,0,1,138.73,279.61Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,279.61l3.11-1.79c.64-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.36-1.14.1-1.14-.58A2.47,2.47,0,0,1,138.73,279.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,268.33l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-14.61,8.43c-.64.36-1.15.1-1.15-.59A2.45,2.45,0,0,1,147.25,268.33Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,268.33l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-14.61,8.43c-.64.36-1.15.1-1.15-.59A2.45,2.45,0,0,1,147.25,268.33Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,274.71l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,274.71Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,274.71l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,274.71Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,301.35l3.1-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,134.37,301.35Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,301.35l3.1-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,134.37,301.35Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,296.45l19-11c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,142.88,296.45Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,296.45l19-11c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-19,11c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,142.88,296.45Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,305.25l3.11-1.8c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,138.73,305.25Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,305.25l3.11-1.8c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,138.73,305.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,311.61l3.11-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.47,2.47,0,0,1,138.73,311.61Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,311.61l3.11-1.79c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.47,2.47,0,0,1,138.73,311.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,300.33l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,300.33Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,300.33l14.61-8.42c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.46,2.46,0,0,1,147.25,300.33Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,306.72l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,147.25,306.72Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,306.72l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.46,2.46,0,0,1-1.15,1.9l-14.61,8.42c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,147.25,306.72Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,286l3.11-1.8c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,138.73,286Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,286l3.11-1.8c.64-.36,1.15-.1,1.15.58a2.46,2.46,0,0,1-1.15,1.91l-3.11,1.79c-.63.37-1.14.11-1.14-.58A2.44,2.44,0,0,1,138.73,286Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,294.88l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-3.1,1.8c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,134.37,294.88Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,294.88l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.42,2.42,0,0,1-1.15,1.9l-3.1,1.8c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,134.37,294.88Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,281.05l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-14.61,8.43c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,147.25,281.05Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,281.05l14.61-8.42c.63-.37,1.15-.11,1.15.58a2.45,2.45,0,0,1-1.15,1.9l-14.61,8.43c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,147.25,281.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,290l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.36-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,290Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,290l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.36-1.15.11-1.15-.58A2.46,2.46,0,0,1,142.88,290Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,320.64l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,134.37,320.64Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,320.64l3.1-1.79c.64-.37,1.15-.11,1.15.58a2.44,2.44,0,0,1-1.15,1.9l-3.1,1.79c-.64.37-1.15.11-1.15-.58A2.44,2.44,0,0,1,134.37,320.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,315.73l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,142.88,315.73Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,315.73l19-11c.63-.36,1.15-.1,1.15.58a2.48,2.48,0,0,1-1.15,1.91l-19,11c-.64.36-1.15.1-1.15-.58A2.46,2.46,0,0,1,142.88,315.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.34,161.76l-3.93-2.27a2.28,2.28,0,0,1-1-1.79V79.52a2.3,2.3,0,0,1,1-1.8l62.91-36.31a2.29,2.29,0,0,1,2.07,0l3.93,2.27a2.3,2.3,0,0,1,1,1.8v78.17a2.3,2.3,0,0,1-1,1.8L61.41,161.76A2.29,2.29,0,0,1,59.34,161.76Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.34,161.76l-3.93-2.27a2.28,2.28,0,0,1-1-1.79V79.52a2.3,2.3,0,0,1,1-1.8l62.91-36.31a2.29,2.29,0,0,1,2.07,0l3.93,2.27a2.3,2.3,0,0,1,1,1.8v78.17a2.3,2.3,0,0,1-1,1.8L61.41,161.76A2.29,2.29,0,0,1,59.34,161.76Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35,45.31c-.08-.54-.51-.74-1-.44L61.41,81.19a2.17,2.17,0,0,0-.73.77l-6-3.46a2.2,2.2,0,0,1,.73-.78l62.91-36.31a2.29,2.29,0,0,1,2.07,0l3.93,2.27A2.33,2.33,0,0,1,125.35,45.31Z",
    style: {
      fill: "#047D95",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.17,161.87a2.28,2.28,0,0,1-1.83-.11l-3.93-2.27a2.29,2.29,0,0,1-1-1.79V79.52a2.08,2.08,0,0,1,.31-1l6,3.46a2.1,2.1,0,0,0-.3,1v78.18C60.38,161.73,60.72,162,61.17,161.87Z",
    style: {
      fill: "#047D95",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.78,45.21s.07,0,.09.14v78.3a1.82,1.82,0,0,1-.8,1.39L61.2,161.34l-.15.07-.09,0c-.1,0-.11-.21-.11-.27V83a1.79,1.79,0,0,1,.8-1.39l62.9-36.32a.43.43,0,0,1,.23-.07m0-.48a1,1,0,0,0-.46.14L61.41,81.19a2.12,2.12,0,0,0-.73.78,2.18,2.18,0,0,0-.3,1v78.17c0,.47.23.74.58.74l.22,0,.23-.11,62.91-36.31a2.31,2.31,0,0,0,1-1.8V45.48a1,1,0,0,0,0-.17.06.06,0,0,0,0,0,.57.57,0,0,0-.56-.54Z",
    style: {
      fill: "#047D95"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.34,93.34a.42.42,0,0,0-.45,0l-.95.63-.21.56a1.1,1.1,0,0,0,.26,1.06,5.66,5.66,0,0,1,.43.52.63.63,0,0,0,.88.21l2.22-1.46a.4.4,0,0,1,.44,0h0Zm-.74-2.51h0L130,89.31l-.17-.07-1.67-.37a.91.91,0,0,0-.95.44l-1.56,3a1.55,1.55,0,0,1-.63.58l.49,1.62a.57.57,0,0,0,.8.36,8.62,8.62,0,0,1,1-.33,1.64,1.64,0,0,0,.95-.72l1.57-3a.87.87,0,0,1,.94-.43l1.67.37ZM127,98.89a4.06,4.06,0,0,1,.32,1c.48,2.86-1.32,6.89-4,9a5.6,5.6,0,0,1-2.84,1.27c.88,1.91,3.12,2.09,5.46.25,2.72-2.14,4.51-6.17,4-9C129.63,99.67,128.48,98.77,127,98.89Zm-1.64,19.42h0l-.07,0Zm-.78-2.17a.58.58,0,0,0-.8-.36,8.27,8.27,0,0,1-1,.34,1,1,0,0,0-.32.14l.07.23a.46.46,0,0,0,.22.29l2.57,1.49a.51.51,0,0,1-.15-.26ZM121.4,97.82l-.15-2.38a1.4,1.4,0,0,1,.47-1.07l2.5-2a.42.42,0,0,1,.5-.06h0l-2.63-1.52a.37.37,0,0,0-.18,0,.54.54,0,0,0-.32.11l-2.5,2a1.44,1.44,0,0,0-.48,1l.16,2.39a1.92,1.92,0,0,1-.39,1.15c-.41.49-.8,1-1.17,1.54a1.25,1.25,0,0,1-1,.51l-1.6-.08a1,1,0,0,0-.92.57l-1.51,3.38a.64.64,0,0,0,.25.82h0l1.79,1a.81.81,0,0,1,0,.46,16.09,16.09,0,0,0-.27,1.62,2.09,2.09,0,0,1-.54,1.09l-2.22,2a1.35,1.35,0,0,0-.37,1.09l.41,2.42a.5.5,0,0,0,.2.33l2.65,1.53h0a.41.41,0,0,1-.21-.33l-.42-2.42a1.35,1.35,0,0,1,.38-1.09l2.21-2a2,2,0,0,0,.54-1.09,15.7,15.7,0,0,1,.28-1.62.81.81,0,0,0-.45-.9l-1.3-.55a.65.65,0,0,1-.33-.85l1.51-3.39a1,1,0,0,1,.92-.57l1.61.08a1.36,1.36,0,0,0,1-.51A17.71,17.71,0,0,1,121,99,1.94,1.94,0,0,0,121.4,97.82Zm-3.76,16.67a.64.64,0,0,0-.89-.2l-1.25.83-.93,2.48a.57.57,0,0,0,.22.69l2.61,1.5a.55.55,0,0,1-.19-.67l1.12-3.05a1.08,1.08,0,0,0-.26-1A4.52,4.52,0,0,1,117.64,114.49Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.34,93.34a.42.42,0,0,0-.45,0l-.95.63-.21.56a1.1,1.1,0,0,0,.26,1.06,5.66,5.66,0,0,1,.43.52.63.63,0,0,0,.88.21l2.22-1.46a.4.4,0,0,1,.44,0h0Zm-.74-2.51h0L130,89.31l-.17-.07-1.67-.37a.91.91,0,0,0-.95.44l-1.56,3a1.55,1.55,0,0,1-.63.58l.49,1.62a.57.57,0,0,0,.8.36,8.62,8.62,0,0,1,1-.33,1.64,1.64,0,0,0,.95-.72l1.57-3a.87.87,0,0,1,.94-.43l1.67.37ZM127,98.89a4.06,4.06,0,0,1,.32,1c.48,2.86-1.32,6.89-4,9a5.6,5.6,0,0,1-2.84,1.27c.88,1.91,3.12,2.09,5.46.25,2.72-2.14,4.51-6.17,4-9C129.63,99.67,128.48,98.77,127,98.89Zm-1.64,19.42h0l-.07,0Zm-.78-2.17a.58.58,0,0,0-.8-.36,8.27,8.27,0,0,1-1,.34,1,1,0,0,0-.32.14l.07.23a.46.46,0,0,0,.22.29l2.57,1.49a.51.51,0,0,1-.15-.26ZM121.4,97.82l-.15-2.38a1.4,1.4,0,0,1,.47-1.07l2.5-2a.42.42,0,0,1,.5-.06h0l-2.63-1.52a.37.37,0,0,0-.18,0,.54.54,0,0,0-.32.11l-2.5,2a1.44,1.44,0,0,0-.48,1l.16,2.39a1.92,1.92,0,0,1-.39,1.15c-.41.49-.8,1-1.17,1.54a1.25,1.25,0,0,1-1,.51l-1.6-.08a1,1,0,0,0-.92.57l-1.51,3.38a.64.64,0,0,0,.25.82h0l1.79,1a.81.81,0,0,1,0,.46,16.09,16.09,0,0,0-.27,1.62,2.09,2.09,0,0,1-.54,1.09l-2.22,2a1.35,1.35,0,0,0-.37,1.09l.41,2.42a.5.5,0,0,0,.2.33l2.65,1.53h0a.41.41,0,0,1-.21-.33l-.42-2.42a1.35,1.35,0,0,1,.38-1.09l2.21-2a2,2,0,0,0,.54-1.09,15.7,15.7,0,0,1,.28-1.62.81.81,0,0,0-.45-.9l-1.3-.55a.65.65,0,0,1-.33-.85l1.51-3.39a1,1,0,0,1,.92-.57l1.61.08a1.36,1.36,0,0,0,1-.51A17.71,17.71,0,0,1,121,99,1.94,1.94,0,0,0,121.4,97.82Zm-3.76,16.67a.64.64,0,0,0-.89-.2l-1.25.83-.93,2.48a.57.57,0,0,0,.22.69l2.61,1.5a.55.55,0,0,1-.19-.67l1.12-3.05a1.08,1.08,0,0,0-.26-1A4.52,4.52,0,0,1,117.64,114.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.19,99.5l-1.6-.08a1,1,0,0,0-.67.24l2.64,1.52a1,1,0,0,1,.66-.24l1.61.08a1.17,1.17,0,0,0,.47-.1l-2.64-1.52A1.14,1.14,0,0,1,116.19,99.5Zm5.4-8.61-2.5,2a1.4,1.4,0,0,0-.41.65L121.31,95a1.43,1.43,0,0,1,.41-.66l2.5-2a.42.42,0,0,1,.5-.06h0l-2.63-1.52A.45.45,0,0,0,121.59,90.89ZM111.2,110.43a1.42,1.42,0,0,0-.34.63l2.63,1.52a1.26,1.26,0,0,1,.35-.63l2.18-2-2.62-1.52Zm22.14-17.09a.4.4,0,0,0-.45,0l-.95.63-.21.56a1,1,0,0,0,0,.7,1.4,1.4,0,0,0,.18.3l0,0,0,0a1.36,1.36,0,0,1,.12.12c.11.13.22.26.32.4a.7.7,0,0,0,.39.29,1,1,0,0,0,.25,0h.08a.8.8,0,0,0,.16-.08l2.22-1.46a.56.56,0,0,1,.28-.1.31.31,0,0,1,.13,0l0,0Zm-.74-2.51h0L130,89.31l-.17-.07-1.67-.37a.91.91,0,0,0-.95.44l-1.56,3a1.49,1.49,0,0,1-.36.4l2.63,1.52a1.25,1.25,0,0,0,.36-.41l1.57-3a.87.87,0,0,1,.94-.43l1.67.37Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.19,99.5l-1.6-.08a1,1,0,0,0-.67.24l2.64,1.52a1,1,0,0,1,.66-.24l1.61.08a1.17,1.17,0,0,0,.47-.1l-2.64-1.52A1.14,1.14,0,0,1,116.19,99.5Zm5.4-8.61-2.5,2a1.4,1.4,0,0,0-.41.65L121.31,95a1.43,1.43,0,0,1,.41-.66l2.5-2a.42.42,0,0,1,.5-.06h0l-2.63-1.52A.45.45,0,0,0,121.59,90.89ZM111.2,110.43a1.42,1.42,0,0,0-.34.63l2.63,1.52a1.26,1.26,0,0,1,.35-.63l2.18-2-2.62-1.52Zm22.14-17.09a.4.4,0,0,0-.45,0l-.95.63-.21.56a1,1,0,0,0,0,.7,1.4,1.4,0,0,0,.18.3l0,0,0,0a1.36,1.36,0,0,1,.12.12c.11.13.22.26.32.4a.7.7,0,0,0,.39.29,1,1,0,0,0,.25,0h.08a.8.8,0,0,0,.16-.08l2.22-1.46a.56.56,0,0,1,.28-.1.31.31,0,0,1,.13,0l0,0Zm-.74-2.51h0L130,89.31l-.17-.07-1.67-.37a.91.91,0,0,0-.95.44l-1.56,3a1.49,1.49,0,0,1-.36.4l2.63,1.52a1.25,1.25,0,0,0,.36-.41l1.57-3a.87.87,0,0,1,.94-.43l1.67.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59,97.6l-.41-2.42a.4.4,0,0,0-.66-.28l-2.22,1.46a.64.64,0,0,1-.88-.21,4.47,4.47,0,0,0-.44-.52,1.1,1.1,0,0,1-.25-1.06l1.12-3a.55.55,0,0,0-.41-.76l-1.67-.37a.89.89,0,0,0-.94.43l-1.57,3a1.68,1.68,0,0,1-.95.72,7.29,7.29,0,0,0-1,.34.58.58,0,0,1-.79-.36l-.56-1.88a.42.42,0,0,0-.71-.22l-2.5,2a1.42,1.42,0,0,0-.47,1.06l.15,2.38A1.92,1.92,0,0,1,121,99c-.41.49-.8,1-1.16,1.53a1.3,1.3,0,0,1-1,.52l-1.61-.08a1,1,0,0,0-.92.57l-1.51,3.39a.63.63,0,0,0,.34.85l1.29.56a.79.79,0,0,1,.45.89,16.18,16.18,0,0,0-.28,1.62,2,2,0,0,1-.54,1.1l-2.22,2a1.38,1.38,0,0,0-.37,1.09l.42,2.42a.4.4,0,0,0,.66.29l2.21-1.46a.64.64,0,0,1,.89.2,4.52,4.52,0,0,0,.43.53,1.08,1.08,0,0,1,.26,1l-1.13,3.06a.55.55,0,0,0,.42.75l1.66.38a.91.91,0,0,0,1-.44l1.57-3a1.66,1.66,0,0,1,1-.71,8.71,8.71,0,0,0,1-.34.56.56,0,0,1,.79.36l.57,1.87a.41.41,0,0,0,.7.22l2.5-2a1.41,1.41,0,0,0,.48-1.06l-.15-2.38a1.92,1.92,0,0,1,.39-1.15c.41-.49.8-1,1.16-1.54a1.3,1.3,0,0,1,1-.52l1.6.08a1,1,0,0,0,.93-.56l1.51-3.39a.65.65,0,0,0-.34-.86l-1.3-.55a.81.81,0,0,1-.44-.9c.12-.54.21-1.08.28-1.61a2,2,0,0,1,.54-1.1l2.21-2A1.29,1.29,0,0,0,136.59,97.6Zm-10.67,12.88c-2.71,2.13-5.31,1.55-5.8-1.3s1.31-6.88,4-9,5.3-1.55,5.8,1.29S128.63,108.35,125.92,110.48Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,87.7a2.22,2.22,0,0,0,.6-1.2l.57-6.4A1.55,1.55,0,0,1,87.21,79L93,75.7a.51.51,0,0,1,.44-.06L90.6,74a.41.41,0,0,0-.19,0,.56.56,0,0,0-.27.08l-5.76,3.33a1.51,1.51,0,0,0-.68,1.07l-.58,6.41a2.07,2.07,0,0,1-.61,1.19,36.85,36.85,0,0,0-3.19,3.39,1.11,1.11,0,0,1-1.14.32L74.5,88.48a.9.9,0,0,0-1,.39L69.22,96.2a.88.88,0,0,0,.19,1.08l3,2.56a1.12,1.12,0,0,1,.29,1.14,34.75,34.75,0,0,0-1.33,4.46,2.2,2.2,0,0,1-.74,1.12l-5.25,3.71a1.46,1.46,0,0,0-.59,1.12V118a.45.45,0,0,0,.2.43l2.83,1.64a.5.5,0,0,1-.2-.44V113a1.57,1.57,0,0,1,.58-1.14l5.26-3.69a2.14,2.14,0,0,0,.74-1.12,35.41,35.41,0,0,1,1.33-4.46,1.11,1.11,0,0,0-.28-1.15l-3-2.55a.88.88,0,0,1-.18-1.09l4.22-7.33a.93.93,0,0,1,1-.39L81,91.4a1.09,1.09,0,0,0,1.13-.32A34.34,34.34,0,0,1,85.35,87.7ZM74.21,118.18a.61.61,0,0,0-.86-.39l-1.24.56c.14.26.27.51.41.74a1.41,1.41,0,0,1,.08,1.25l-3.42,6.88a.77.77,0,0,0,.31,1l2.82,1.64a.8.8,0,0,1-.3-1L75.43,122a1.43,1.43,0,0,0-.08-1.24A11.17,11.17,0,0,1,74.21,118.18Zm12.3,12.47L86,125.06a.61.61,0,0,0-.77-.54,11.06,11.06,0,0,1-1.93.27l.43,4.23a.48.48,0,0,0,.21.39l2.84,1.64A.49.49,0,0,1,86.51,130.65ZM109.57,85h0a.5.5,0,0,0-.45,0l-3.88,1.75a11.68,11.68,0,0,1,.74,1.8.61.61,0,0,0,.85.4L112,86.61a.42.42,0,0,1,.45,0v0ZM100.3,73.32,96,79.72a1.43,1.43,0,0,1-1.11.56q-.42,0-.84,0l.13,1.37a.62.62,0,0,0,.77.54,11.9,11.9,0,0,1,2.78-.29,1.4,1.4,0,0,0,1.11-.55l4.26-6.4a.77.77,0,0,1,1-.23l-2.84-1.64A.78.78,0,0,0,100.3,73.32ZM95.72,91A8.78,8.78,0,0,1,97,96.1c0,6.21-4.35,13.75-9.72,16.85-2.1,1.21-3.88,1.62-5.28,1.28,1.74,2,4.71,2.31,8.11.36,5.37-3.1,9.73-10.65,9.73-16.85C99.82,94,98.2,91.55,95.72,91Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,87.7a2.22,2.22,0,0,0,.6-1.2l.57-6.4A1.55,1.55,0,0,1,87.21,79L93,75.7a.51.51,0,0,1,.44-.06L90.6,74a.41.41,0,0,0-.19,0,.56.56,0,0,0-.27.08l-5.76,3.33a1.51,1.51,0,0,0-.68,1.07l-.58,6.41a2.07,2.07,0,0,1-.61,1.19,36.85,36.85,0,0,0-3.19,3.39,1.11,1.11,0,0,1-1.14.32L74.5,88.48a.9.9,0,0,0-1,.39L69.22,96.2a.88.88,0,0,0,.19,1.08l3,2.56a1.12,1.12,0,0,1,.29,1.14,34.75,34.75,0,0,0-1.33,4.46,2.2,2.2,0,0,1-.74,1.12l-5.25,3.71a1.46,1.46,0,0,0-.59,1.12V118a.45.45,0,0,0,.2.43l2.83,1.64a.5.5,0,0,1-.2-.44V113a1.57,1.57,0,0,1,.58-1.14l5.26-3.69a2.14,2.14,0,0,0,.74-1.12,35.41,35.41,0,0,1,1.33-4.46,1.11,1.11,0,0,0-.28-1.15l-3-2.55a.88.88,0,0,1-.18-1.09l4.22-7.33a.93.93,0,0,1,1-.39L81,91.4a1.09,1.09,0,0,0,1.13-.32A34.34,34.34,0,0,1,85.35,87.7ZM74.21,118.18a.61.61,0,0,0-.86-.39l-1.24.56c.14.26.27.51.41.74a1.41,1.41,0,0,1,.08,1.25l-3.42,6.88a.77.77,0,0,0,.31,1l2.82,1.64a.8.8,0,0,1-.3-1L75.43,122a1.43,1.43,0,0,0-.08-1.24A11.17,11.17,0,0,1,74.21,118.18Zm12.3,12.47L86,125.06a.61.61,0,0,0-.77-.54,11.06,11.06,0,0,1-1.93.27l.43,4.23a.48.48,0,0,0,.21.39l2.84,1.64A.49.49,0,0,1,86.51,130.65ZM109.57,85h0a.5.5,0,0,0-.45,0l-3.88,1.75a11.68,11.68,0,0,1,.74,1.8.61.61,0,0,0,.85.4L112,86.61a.42.42,0,0,1,.45,0v0ZM100.3,73.32,96,79.72a1.43,1.43,0,0,1-1.11.56q-.42,0-.84,0l.13,1.37a.62.62,0,0,0,.77.54,11.9,11.9,0,0,1,2.78-.29,1.4,1.4,0,0,0,1.11-.55l4.26-6.4a.77.77,0,0,1,1-.23l-2.84-1.64A.78.78,0,0,0,100.3,73.32ZM95.72,91A8.78,8.78,0,0,1,97,96.1c0,6.21-4.35,13.75-9.72,16.85-2.1,1.21-3.88,1.62-5.28,1.28,1.74,2,4.71,2.31,8.11.36,5.37-3.1,9.73-10.65,9.73-16.85C99.82,94,98.2,91.55,95.72,91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,93.68V87a.43.43,0,0,0-.65-.42l-5.13,2.31a.61.61,0,0,1-.85-.4A11.58,11.58,0,0,0,104.83,86a1.39,1.39,0,0,1-.08-1.24l3.41-6.89a.77.77,0,0,0-.3-1l-3.71-2.14a.78.78,0,0,0-1,.24l-4.25,6.4a1.43,1.43,0,0,1-1.12.56,10.81,10.81,0,0,0-2.77.28.61.61,0,0,1-.77-.54l-.56-5.6A.43.43,0,0,0,93,75.7L87.21,79a1.59,1.59,0,0,0-.69,1.08L86,86.5a2.18,2.18,0,0,1-.6,1.2,35.5,35.5,0,0,0-3.2,3.38A1.09,1.09,0,0,1,81,91.4l-3.7-1.29a.88.88,0,0,0-1,.39l-4.24,7.33a.92.92,0,0,0,.19,1.09l3,2.55a1.1,1.1,0,0,1,.29,1.14,34.42,34.42,0,0,0-1.33,4.47,2.15,2.15,0,0,1-.74,1.11l-5.26,3.71a1.53,1.53,0,0,0-.58,1.13v6.64a.43.43,0,0,0,.65.43l5.13-2.31a.6.6,0,0,1,.85.39,11.58,11.58,0,0,0,1.14,2.54,1.41,1.41,0,0,1,.08,1.25L72,128.85a.79.79,0,0,0,.31,1L76,132a.77.77,0,0,0,1-.23l4.26-6.41a1.42,1.42,0,0,1,1.11-.55,11.82,11.82,0,0,0,2.78-.28.6.6,0,0,1,.76.54l.57,5.59a.43.43,0,0,0,.69.36L93,127.69a1.54,1.54,0,0,0,.68-1.08l.58-6.4a2.18,2.18,0,0,1,.6-1.2,35.5,35.5,0,0,0,3.2-3.38,1.09,1.09,0,0,1,1.13-.33l3.69,1.29a.89.89,0,0,0,1-.38l4.23-7.33a.9.9,0,0,0-.18-1.09l-3-2.56a1.1,1.1,0,0,1-.28-1.14A35.41,35.41,0,0,0,106,99.63a2.12,2.12,0,0,1,.73-1.12l5.26-3.7A1.53,1.53,0,0,0,112.6,93.68Zm-22.51,20.9c-5.37,3.11-9.73.59-9.73-5.61s4.36-13.75,9.73-16.85,9.72-.58,9.72,5.62S95.46,111.48,90.09,114.58Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,88.87,69.22,96.2a.88.88,0,0,0-.09.53L72,98.36a.83.83,0,0,1,.11-.53l4.22-7.33a.89.89,0,0,1,.72-.42l-2.81-1.65A.86.86,0,0,0,73.46,88.87Zm-2.87,17.69-5.25,3.71a1.21,1.21,0,0,0-.35.39l2.81,1.63a1.76,1.76,0,0,1,.36-.4l5.26-3.69a2.46,2.46,0,0,0,.42-.43L71,106.12A1.75,1.75,0,0,1,70.59,106.56Zm19.55-32.5-5.76,3.33a1.53,1.53,0,0,0-.58.69l2.83,1.64a1.5,1.5,0,0,1,.58-.7L93,75.7a.51.51,0,0,1,.44-.06L90.6,74A.45.45,0,0,0,90.14,74.06Zm10.16-.74L96,79.72a.91.91,0,0,1-.28.27l2.84,1.64a1.07,1.07,0,0,0,.28-.28l4.26-6.4a.77.77,0,0,1,1-.23l-2.84-1.64A.78.78,0,0,0,100.3,73.32Zm12.07,13.27,0,0h0ZM109.56,85a.54.54,0,0,0-.45,0l-3.88,1.75a7.55,7.55,0,0,1,.43,1,7.42,7.42,0,0,1,.3.83.69.69,0,0,0,.24.33.6.6,0,0,0,.62.07L112,86.61a.53.53,0,0,1,.24-.06.4.4,0,0,1,.15,0h0L109.56,85Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,88.87,69.22,96.2a.88.88,0,0,0-.09.53L72,98.36a.83.83,0,0,1,.11-.53l4.22-7.33a.89.89,0,0,1,.72-.42l-2.81-1.65A.86.86,0,0,0,73.46,88.87Zm-2.87,17.69-5.25,3.71a1.21,1.21,0,0,0-.35.39l2.81,1.63a1.76,1.76,0,0,1,.36-.4l5.26-3.69a2.46,2.46,0,0,0,.42-.43L71,106.12A1.75,1.75,0,0,1,70.59,106.56Zm19.55-32.5-5.76,3.33a1.53,1.53,0,0,0-.58.69l2.83,1.64a1.5,1.5,0,0,1,.58-.7L93,75.7a.51.51,0,0,1,.44-.06L90.6,74A.45.45,0,0,0,90.14,74.06Zm10.16-.74L96,79.72a.91.91,0,0,1-.28.27l2.84,1.64a1.07,1.07,0,0,0,.28-.28l4.26-6.4a.77.77,0,0,1,1-.23l-2.84-1.64A.78.78,0,0,0,100.3,73.32Zm12.07,13.27,0,0h0ZM109.56,85a.54.54,0,0,0-.45,0l-3.88,1.75a7.55,7.55,0,0,1,.43,1,7.42,7.42,0,0,1,.3.83.69.69,0,0,0,.24.33.6.6,0,0,0,.62.07L112,86.61a.53.53,0,0,1,.24-.06.4.4,0,0,1,.15,0h0L109.56,85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.68,
    cy: 425.14,
    rx: 29.38,
    ry: 12.04,
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.68,
    cy: 425.14,
    rx: 29.38,
    ry: 12.04,
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.68,
    cy: 425.14,
    rx: 29.38,
    ry: 12.04,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,418.92a13.06,13.06,0,0,1,26.1,0c0,.13,0,.24,0,.37s0,.23,0,.36c-.15,1.81-1.42,3.58-3.82,5-5.09,2.94-13.37,2.94-18.47,0-2.39-1.39-3.66-3.16-3.81-5,0-.13,0-.24,0-.36S43.56,419.05,43.57,418.92Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,418.92a13.06,13.06,0,0,1,26.1,0c0,.13,0,.24,0,.37s0,.23,0,.36c-.15,1.81-1.42,3.58-3.82,5-5.09,2.94-13.37,2.94-18.47,0-2.39-1.39-3.66-3.16-3.81-5,0-.13,0-.24,0-.36S43.56,419.05,43.57,418.92Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,407.53h0a13,13,0,0,1,18.72,11.39c0,.13,0,.24,0,.37s0,.23,0,.36c-.15,1.81-1.42,3.58-3.82,5a17.48,17.48,0,0,1-6.55,2c3.39-.58,5.58-4.36,4.54-8.54C62.63,413.28,57.73,406.28,51,407.53Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,419.65c0-.13,0-.24,0-.36s0-.24,0-.37A13,13,0,0,1,48,409.49c-1.42,1.46-4.57,6.95-1.14,11.14,2.25,2.76,13,6.69,21.76,1.64a9.15,9.15,0,0,1-2.77,2.35c-5.09,2.94-13.37,2.94-18.47,0C45,423.23,43.72,421.46,43.57,419.65Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.75,409.17c-.58,1.33.54,3.11,2.51,4s4,.49,4.62-.84-.54-3.11-2.5-4S57.34,407.84,56.75,409.17Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.31,414.58A1.72,1.72,0,1,0,66.4,414,1.55,1.55,0,0,0,64.31,414.58Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,419.31a11.08,11.08,0,0,0-22.16,0c0,.1,0,.2,0,.31s0,.2,0,.31c.13,1.53,1.21,3,3.24,4.21a17.35,17.35,0,0,0,15.69,0c2-1.17,3.11-2.68,3.23-4.21,0-.11,0-.21,0-.31S91.69,419.41,91.68,419.31Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,419.31a11.08,11.08,0,0,0-22.16,0c0,.1,0,.2,0,.31s0,.2,0,.31c.13,1.53,1.21,3,3.24,4.21a17.35,17.35,0,0,0,15.69,0c2-1.17,3.11-2.68,3.23-4.21,0-.11,0-.21,0-.31S91.69,419.41,91.68,419.31Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.41,409.63h0a11.08,11.08,0,0,0-15.89,9.68c0,.1,0,.2,0,.31s0,.2,0,.31c.13,1.53,1.21,3,3.24,4.21a14.75,14.75,0,0,0,5.57,1.74c-2.88-.5-4.74-3.71-3.86-7.25C75.5,414.51,79.66,408.57,85.41,409.63Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,419.93c0-.11,0-.21,0-.31s0-.21,0-.31a11,11,0,0,0-3.76-8c1.21,1.24,3.88,5.9,1,9.46-1.91,2.34-11,5.68-18.48,1.39a7.76,7.76,0,0,0,2.35,2,17.35,17.35,0,0,0,15.69,0C90.48,423,91.56,421.46,91.68,419.93Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49,411c.5,1.13-.46,2.65-2.13,3.38s-3.43.41-3.93-.72.46-2.64,2.13-3.37S80,409.89,80.49,411Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.07,415.62a1.46,1.46,0,1,1-1.78-.49A1.33,1.33,0,0,1,74.07,415.62Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,424a7.33,7.33,0,0,0-14.66,0v.41a3.78,3.78,0,0,0,2.15,2.79,11.48,11.48,0,0,0,10.37,0,3.76,3.76,0,0,0,2.14-2.79,1.34,1.34,0,0,0,0-.2A1.48,1.48,0,0,0,100.59,424Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,424a7.33,7.33,0,0,0-14.66,0v.41a3.78,3.78,0,0,0,2.15,2.79,11.48,11.48,0,0,0,10.37,0,3.76,3.76,0,0,0,2.14-2.79,1.34,1.34,0,0,0,0-.2A1.48,1.48,0,0,0,100.59,424Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,417.57h0A7.32,7.32,0,0,0,85.93,424v.41a3.78,3.78,0,0,0,2.15,2.79,9.76,9.76,0,0,0,3.68,1.15c-1.91-.33-3.14-2.45-2.55-4.8C89.89,420.8,92.64,416.87,96.44,417.57Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,424.38a1.34,1.34,0,0,0,0-.2,1.48,1.48,0,0,0,0-.21,7.34,7.34,0,0,0-2.49-5.3c.8.82,2.57,3.91.64,6.26-1.26,1.55-7.27,3.76-12.22.92a5.08,5.08,0,0,0,1.56,1.32,11.48,11.48,0,0,0,10.37,0A3.76,3.76,0,0,0,100.59,424.38Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.19,418.49c.32.75-.31,1.75-1.41,2.24s-2.27.27-2.6-.48.3-1.74,1.41-2.23S92.86,417.75,93.19,418.49Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.94,421.54a1,1,0,1,1-1.17-.33A.87.87,0,0,1,88.94,421.54Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,424.9a10,10,0,0,0-19.92,0,2.62,2.62,0,0,0,0,.28,2.72,2.72,0,0,0,0,.28c.11,1.38,1.08,2.73,2.91,3.79a15.63,15.63,0,0,0,14.1,0c1.82-1.06,2.79-2.41,2.91-3.79a2.72,2.72,0,0,0,0-.28A2.62,2.62,0,0,0,114.77,424.9Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,424.9a10,10,0,0,0-19.92,0,2.62,2.62,0,0,0,0,.28,2.72,2.72,0,0,0,0,.28c.11,1.38,1.08,2.73,2.91,3.79a15.63,15.63,0,0,0,14.1,0c1.82-1.06,2.79-2.41,2.91-3.79a2.72,2.72,0,0,0,0-.28A2.62,2.62,0,0,0,114.77,424.9Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,416.21h0a9.8,9.8,0,0,0-4.32-1,10,10,0,0,0-10,9.69,2.62,2.62,0,0,0,0,.28,2.72,2.72,0,0,0,0,.28c.11,1.38,1.08,2.73,2.91,3.79a13.28,13.28,0,0,0,5,1.56c-2.58-.45-4.25-3.33-3.46-6.52C100.22,420.59,104,415.25,109.13,416.21Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,425.46a2.72,2.72,0,0,0,0-.28,2.62,2.62,0,0,0,0-.28,9.94,9.94,0,0,0-3.38-7.2c1.08,1.11,3.48,5.31.87,8.51-1.72,2.1-9.89,5.1-16.61,1.24a7.1,7.1,0,0,0,2.11,1.8,15.63,15.63,0,0,0,14.1,0C113.68,428.19,114.65,426.84,114.77,425.46Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71,417.46c.44,1-.41,2.37-1.92,3s-3.08.37-3.53-.64.42-2.38,1.92-3S104.26,416.44,104.71,417.46Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94,421.59a1.18,1.18,0,0,1-.76,1.47,1.06,1.06,0,1,1-.84-1.91A1.18,1.18,0,0,1,98.94,421.59Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.46,367.44A18.16,18.16,0,0,1,81,381.32a11.87,11.87,0,0,0-4.32,9v47.24a3.72,3.72,0,0,1-2.19,3.07,9.29,9.29,0,0,1-2.75,1,12.88,12.88,0,0,1-5.1,0,9.41,9.41,0,0,1-2.74-1,3.74,3.74,0,0,1-2.19-3.07V390.27a11.76,11.76,0,0,0-4.29-8.93,18.12,18.12,0,0,1-6.46-14,18.24,18.24,0,0,1,36.47.15Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.46,367.44A18.16,18.16,0,0,1,81,381.32a11.87,11.87,0,0,0-4.32,9v47.24a3.72,3.72,0,0,1-2.19,3.07,9.29,9.29,0,0,1-2.75,1,12.88,12.88,0,0,1-5.1,0,9.41,9.41,0,0,1-2.74-1,3.74,3.74,0,0,1-2.19-3.07V390.27a11.76,11.76,0,0,0-4.29-8.93,18.12,18.12,0,0,1-6.46-14,18.24,18.24,0,0,1,36.47.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,367.44a10.14,10.14,0,0,1-4.29,8.28,8.28,8.28,0,0,0-3.34,6.77v55.1a2.58,2.58,0,0,1-2.52,2.61h-.06a2.58,2.58,0,0,1-2.52-2.61V382.36a8.1,8.1,0,0,0-3.34-6.64,10.16,10.16,0,0,1-4.28-8.57,10.18,10.18,0,0,1,20.35.29Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,367.44a10.14,10.14,0,0,1-4.29,8.28,8.28,8.28,0,0,0-3.34,6.77v55.1a2.58,2.58,0,0,1-2.52,2.61h-.06a2.58,2.58,0,0,1-2.52-2.61V382.36a8.1,8.1,0,0,0-3.34-6.64,10.16,10.16,0,0,1-4.28-8.57,10.18,10.18,0,0,1,20.35.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,374.18a4.76,4.76,0,1,1,4.75,4.75A4.76,4.76,0,0,1,72.08,374.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93,364.71a2.91,2.91,0,1,1,2.9,2.91A2.9,2.9,0,0,1,73.93,364.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.38,360.08a1.44,1.44,0,1,1,1.44,1.44A1.43,1.43,0,0,1,68.38,360.08Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,361.81a3.91,3.91,0,1,1,3.91,3.9A3.91,3.91,0,0,1,56.88,361.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.06,
    cy: 368.86,
    r: 1.83,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,375.27a3,3,0,1,1,3,3A3,3,0,0,1,57.6,375.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69,379.77a2.45,2.45,0,1,1,2.45,2.45A2.45,2.45,0,0,1,64.69,379.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75,364.71A1.25,1.25,0,1,1,54,366,1.25,1.25,0,0,1,52.75,364.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.92,359.55a1.65,1.65,0,1,1,1.65,1.64A1.65,1.65,0,0,1,79.92,359.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.56,367.62a1.66,1.66,0,1,1,1.65,1.65A1.65,1.65,0,0,1,81.56,367.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.41,369a1.66,1.66,0,1,1,1.65,1.65A1.65,1.65,0,0,1,64.41,369Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,427.76a6.07,6.07,0,0,0-12.14,0v.34a3.11,3.11,0,0,0,1.78,2.31,9.49,9.49,0,0,0,8.59,0,3.12,3.12,0,0,0,1.77-2.31,1.45,1.45,0,0,0,0-.34Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,427.76a6.07,6.07,0,0,0-12.14,0v.34a3.11,3.11,0,0,0,1.78,2.31,9.49,9.49,0,0,0,8.59,0,3.12,3.12,0,0,0,1.77-2.31,1.45,1.45,0,0,0,0-.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47,422.46h0a6.08,6.08,0,0,0-8.71,5.3v.34a3.11,3.11,0,0,0,1.78,2.31,8,8,0,0,0,3,.95,3.06,3.06,0,0,1-2.11-4C116,425.14,118.32,421.88,121.47,422.46Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,428.1a1.45,1.45,0,0,0,0-.34,6,6,0,0,0-2.06-4.39c.66.68,2.13,3.24.53,5.19-1,1.28-6,3.11-10.12.76a4.32,4.32,0,0,0,1.29,1.09,9.49,9.49,0,0,0,8.59,0A3.12,3.12,0,0,0,124.9,428.1Z",
    style: {
      fill: "#047D95",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,423.23c.27.61-.25,1.44-1.17,1.84s-1.87.23-2.15-.39.25-1.44,1.17-1.85S118.5,422.61,118.77,423.23Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.25,425.74a.8.8,0,0,1-1.43.63.72.72,0,0,1,.46-.89A.71.71,0,0,1,115.25,425.74Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.11,432.32a8.36,8.36,0,0,0-16.72,0v.47a4.3,4.3,0,0,0,2.45,3.18,13,13,0,0,0,11.83,0,4.31,4.31,0,0,0,2.44-3.18,1.77,1.77,0,0,0,0-.23A1.93,1.93,0,0,0,117.11,432.32Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.11,432.32a8.36,8.36,0,0,0-16.72,0v.47a4.3,4.3,0,0,0,2.45,3.18,13,13,0,0,0,11.83,0,4.31,4.31,0,0,0,2.44-3.18,1.77,1.77,0,0,0,0-.23A1.93,1.93,0,0,0,117.11,432.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.38,425h0a8.34,8.34,0,0,0-12,7.29v.47a4.3,4.3,0,0,0,2.45,3.18,11,11,0,0,0,4.19,1.31c-2.17-.37-3.57-2.8-2.9-5.47C104.9,428.71,108,424.23,112.38,425Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.11,432.79a1.77,1.77,0,0,0,0-.23,1.93,1.93,0,0,0,0-.24,8.3,8.3,0,0,0-2.84-6c.91.94,2.93,4.46.73,7.14-1.44,1.76-8.29,4.28-13.94,1.05a5.91,5.91,0,0,0,1.78,1.5,13,13,0,0,0,11.83,0A4.31,4.31,0,0,0,117.11,432.79Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67,426.08c.37.85-.35,2-1.61,2.54s-2.59.32-3-.54.34-2,1.6-2.54S108.29,425.22,108.67,426.08Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82,429.55a1.1,1.1,0,0,1-2,.86,1.1,1.1,0,0,1,2-.86Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.94,435.3a10.38,10.38,0,0,0-20.75,0,2.81,2.81,0,0,0,0,.29,2.62,2.62,0,0,0,0,.28c.12,1.44,1.13,2.85,3,3.95a16.23,16.23,0,0,0,14.68,0c1.9-1.1,2.91-2.51,3-3.95a2.62,2.62,0,0,0,0-.28A2.81,2.81,0,0,0,104.94,435.3Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.94,435.3a10.38,10.38,0,0,0-20.75,0,2.81,2.81,0,0,0,0,.29,2.62,2.62,0,0,0,0,.28c.12,1.44,1.13,2.85,3,3.95a16.23,16.23,0,0,0,14.68,0c1.9-1.1,2.91-2.51,3-3.95a2.62,2.62,0,0,0,0-.28A2.81,2.81,0,0,0,104.94,435.3Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.07,426.24h0a10.36,10.36,0,0,0-14.88,9.06,2.81,2.81,0,0,0,0,.29,2.62,2.62,0,0,0,0,.28c.12,1.44,1.13,2.85,3,3.95a13.69,13.69,0,0,0,5.2,1.63c-2.69-.47-4.43-3.47-3.6-6.79C89.79,430.81,93.68,425.24,99.07,426.24Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.94,435.87a2.62,2.62,0,0,0,0-.28,2.81,2.81,0,0,0,0-.29,10.32,10.32,0,0,0-3.53-7.5c1.13,1.16,3.64,5.53.91,8.86C100.53,438.85,92,442,85,438a6.93,6.93,0,0,0,2.2,1.87,16.23,16.23,0,0,0,14.68,0C103.81,438.72,104.82,437.31,104.94,435.87Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,427.54c.46,1.06-.43,2.48-2,3.16s-3.22.39-3.68-.67.43-2.47,2-3.16S94,426.49,94.46,427.54Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.45,431.85a1.37,1.37,0,1,1-1.66-.46A1.23,1.23,0,0,1,88.45,431.85Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,429.18a3.67,3.67,0,0,0-7.33,0,.41.41,0,0,0,0,.11.38.38,0,0,0,0,.1,1.86,1.86,0,0,0,1.07,1.4,5.78,5.78,0,0,0,5.19,0,1.89,1.89,0,0,0,1.07-1.4v-.21Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,429.18a3.67,3.67,0,0,0-7.33,0,.41.41,0,0,0,0,.11.38.38,0,0,0,0,.1,1.86,1.86,0,0,0,1.07,1.4,5.78,5.78,0,0,0,5.19,0,1.89,1.89,0,0,0,1.07-1.4v-.21Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,426h0a3.67,3.67,0,0,0-5.25,3.2.41.41,0,0,0,0,.11.38.38,0,0,0,0,.1,1.86,1.86,0,0,0,1.07,1.4,4.85,4.85,0,0,0,1.84.57,1.86,1.86,0,0,1-1.28-2.4C124.68,427.6,126.06,425.63,128,426Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,429.39v-.21a3.68,3.68,0,0,0-1.24-2.65c.39.41,1.28,2,.32,3.14a5.64,5.64,0,0,1-6.12.45,2.63,2.63,0,0,0,.78.67,5.78,5.78,0,0,0,5.19,0A1.89,1.89,0,0,0,130,429.39Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,426.44c.16.38-.16.88-.71,1.12s-1.13.14-1.3-.24.15-.87.71-1.11S126.17,426.07,126.34,426.44Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.21,428a.48.48,0,1,1-.59-.17A.44.44,0,0,1,124.21,428Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.09,424.77a6.07,6.07,0,0,1,12.14,0v.34a3.13,3.13,0,0,1-1.78,2.31,9.49,9.49,0,0,1-8.59,0,3.14,3.14,0,0,1-1.77-2.31,1.45,1.45,0,0,1,0-.34Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.09,424.77a6.07,6.07,0,0,1,12.14,0v.34a3.13,3.13,0,0,1-1.78,2.31,9.49,9.49,0,0,1-8.59,0,3.14,3.14,0,0,1-1.77-2.31,1.45,1.45,0,0,1,0-.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.52,419.47h0a6.06,6.06,0,0,1,8.71,5.3v.34a3.13,3.13,0,0,1-1.78,2.31,8,8,0,0,1-3.05.95,3.07,3.07,0,0,0,2.12-4C26,422.14,23.68,418.89,20.52,419.47Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.09,425.11a1.45,1.45,0,0,1,0-.34,6,6,0,0,1,2.06-4.39c-.66.68-2.13,3.24-.53,5.19,1.05,1.28,6,3.11,10.12.76a4.47,4.47,0,0,1-1.29,1.09,9.49,9.49,0,0,1-8.59,0A3.14,3.14,0,0,1,17.09,425.11Z",
    style: {
      fill: "#047D95",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.22,420.23c-.27.62.25,1.45,1.17,1.85s1.88.23,2.15-.39-.25-1.45-1.17-1.85S23.49,419.61,23.22,420.23Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.74,422.75a.72.72,0,0,0,.46.9.72.72,0,0,0,1-.27.73.73,0,0,0-.46-.9A.72.72,0,0,0,26.74,422.75Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.76,424.14a8.81,8.81,0,0,1,17.61,0v.49A4.53,4.53,0,0,1,44.79,428a13.81,13.81,0,0,1-12.46,0,4.54,4.54,0,0,1-2.57-3.35,2.18,2.18,0,0,1,0-.25A1.93,1.93,0,0,1,29.76,424.14Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.76,424.14a8.81,8.81,0,0,1,17.61,0v.49A4.53,4.53,0,0,1,44.79,428a13.81,13.81,0,0,1-12.46,0,4.54,4.54,0,0,1-2.57-3.35,2.18,2.18,0,0,1,0-.25A1.93,1.93,0,0,1,29.76,424.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74,416.45h0a8.8,8.8,0,0,1,12.63,7.69v.49A4.53,4.53,0,0,1,44.79,428a11.94,11.94,0,0,1-4.42,1.38c2.29-.4,3.76-2.95,3.06-5.77C42.62,420.33,39.31,415.6,34.74,416.45Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.76,424.63a2.18,2.18,0,0,1,0-.25,1.93,1.93,0,0,1,0-.24,8.73,8.73,0,0,1,3-6.37c-1,1-3.09,4.69-.77,7.52,1.52,1.86,8.74,4.51,14.68,1.1A6,6,0,0,1,44.79,428a13.81,13.81,0,0,1-12.46,0A4.54,4.54,0,0,1,29.76,424.63Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65,417.55c-.39.9.37,2.1,1.69,2.69s2.73.32,3.12-.57-.36-2.1-1.69-2.68S39.05,416.66,38.65,417.55Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75,421.21a1.16,1.16,0,1,0,1.41-.39A1.05,1.05,0,0,0,43.75,421.21Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49,429.3a8.36,8.36,0,0,1,16.71,0,1.93,1.93,0,0,1,0,.24,1.77,1.77,0,0,1,0,.23A4.29,4.29,0,0,1,37.76,433a13.07,13.07,0,0,1-11.84,0,4.3,4.3,0,0,1-2.43-3.18,1.77,1.77,0,0,1,0-.23A1.93,1.93,0,0,1,23.49,429.3Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49,429.3a8.36,8.36,0,0,1,16.71,0,1.93,1.93,0,0,1,0,.24,1.77,1.77,0,0,1,0,.23A4.29,4.29,0,0,1,37.76,433a13.07,13.07,0,0,1-11.84,0,4.3,4.3,0,0,1-2.43-3.18,1.77,1.77,0,0,1,0-.23A1.93,1.93,0,0,1,23.49,429.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.22,422h0a8.27,8.27,0,0,1,3.62-.84,8.36,8.36,0,0,1,8.36,8.13,1.93,1.93,0,0,1,0,.24,1.77,1.77,0,0,1,0,.23A4.29,4.29,0,0,1,37.76,433a11.07,11.07,0,0,1-4.2,1.31c2.17-.37,3.57-2.8,2.91-5.47C35.69,425.69,32.56,421.21,28.22,422Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49,429.77a1.77,1.77,0,0,1,0-.23,1.93,1.93,0,0,1,0-.24,8.33,8.33,0,0,1,2.83-6c-.9.94-2.92,4.46-.73,7.14,1.44,1.76,8.3,4.28,13.94,1.05a6,6,0,0,1-1.77,1.5,13.07,13.07,0,0,1-11.84,0A4.3,4.3,0,0,1,23.49,429.77Z",
    style: {
      fill: "#047D95",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.93,423.06c-.38.85.34,2,1.6,2.54s2.59.31,3-.54-.35-2-1.61-2.54S32.3,422.2,31.93,423.06Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.77,426.53a1.1,1.1,0,1,0,1.34-.38A1,1,0,0,0,36.77,426.53Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,434a10.37,10.37,0,0,1,20.74,0,4.21,4.21,0,0,1,0,.58c-.11,1.44-1.13,2.85-3,3.95a16.23,16.23,0,0,1-14.68,0c-1.9-1.1-2.91-2.51-3-3.95a4.21,4.21,0,0,1,0-.58Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,434a10.37,10.37,0,0,1,20.74,0,4.21,4.21,0,0,1,0,.58c-.11,1.44-1.13,2.85-3,3.95a16.23,16.23,0,0,1-14.68,0c-1.9-1.1-2.91-2.51-3-3.95a4.21,4.21,0,0,1,0-.58Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.37,425h0A10.35,10.35,0,0,1,58.24,434a4.21,4.21,0,0,1,0,.58c-.11,1.44-1.13,2.85-3,3.95A13.74,13.74,0,0,1,50,440.2c2.69-.47,4.44-3.47,3.61-6.79C52.65,429.56,48.76,424,43.37,425Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,434.62a4.21,4.21,0,0,1,0-.58A10.32,10.32,0,0,1,41,426.55c-1.13,1.16-3.63,5.52-.91,8.85,1.79,2.19,10.3,5.32,17.3,1.3a7.3,7.3,0,0,1-2.2,1.87,16.23,16.23,0,0,1-14.68,0C38.63,437.47,37.62,436.06,37.5,434.62Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,426.29c-.47,1.06.42,2.47,2,3.16s3.21.39,3.68-.67-.43-2.47-2-3.16S48.44,425.23,48,426.29Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,430.6a1.36,1.36,0,1,0,1.66-.46A1.23,1.23,0,0,0,54,430.6Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,438.69a9.47,9.47,0,0,0-18.94,0,2.26,2.26,0,0,0,0,.26,2.53,2.53,0,0,0,0,.27c.11,1.31,1,2.59,2.77,3.6a14.79,14.79,0,0,0,13.4,0c1.74-1,2.66-2.29,2.77-3.6a2.53,2.53,0,0,0,0-.27A2.26,2.26,0,0,0,87.78,438.69Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,438.69a9.47,9.47,0,0,0-18.94,0,2.26,2.26,0,0,0,0,.26,2.53,2.53,0,0,0,0,.27c.11,1.31,1,2.59,2.77,3.6a14.79,14.79,0,0,0,13.4,0c1.74-1,2.66-2.29,2.77-3.6a2.53,2.53,0,0,0,0-.27A2.26,2.26,0,0,0,87.78,438.69Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.42,430.42h0a9.45,9.45,0,0,0-13.58,8.27,2.26,2.26,0,0,0,0,.26,2.53,2.53,0,0,0,0,.27c.11,1.31,1,2.59,2.77,3.6a12.61,12.61,0,0,0,4.75,1.48c-2.45-.42-4-3.16-3.29-6.19C74,434.59,77.5,429.51,82.42,430.42Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,439.22a2.53,2.53,0,0,0,0-.27,2.26,2.26,0,0,0,0-.26,9.44,9.44,0,0,0-3.22-6.85c1,1.06,3.32,5.05.83,8.09-1.63,2-9.4,4.85-15.79,1.18a6.56,6.56,0,0,0,2,1.71,14.79,14.79,0,0,0,13.4,0C86.75,441.81,87.67,440.53,87.78,439.22Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.21,431.61c.43,1-.39,2.26-1.82,2.88s-2.93.36-3.35-.61.39-2.26,1.82-2.88S77.79,430.64,78.21,431.61Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,435.54a1.24,1.24,0,1,1-1.51-.42A1.13,1.13,0,0,1,72.72,435.54Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.59,439.42a9,9,0,0,1,18,0,2.18,2.18,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26A4.62,4.62,0,0,1,66,443.35a14,14,0,0,1-12.75,0,4.62,4.62,0,0,1-2.63-3.42,2.26,2.26,0,0,1,0-.26A2.18,2.18,0,0,1,50.59,439.42Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.59,439.42a9,9,0,0,1,18,0,2.18,2.18,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26A4.62,4.62,0,0,1,66,443.35a14,14,0,0,1-12.75,0,4.62,4.62,0,0,1-2.63-3.42,2.26,2.26,0,0,1,0-.26A2.18,2.18,0,0,1,50.59,439.42Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.69,431.56h0a9,9,0,0,1,12.91,7.86,2.18,2.18,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26A4.62,4.62,0,0,1,66,443.35a11.92,11.92,0,0,1-4.53,1.41c2.34-.4,3.86-3,3.14-5.89C63.74,435.53,60.36,430.7,55.69,431.56Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.59,439.93a2.26,2.26,0,0,1,0-.26,2.18,2.18,0,0,1,0-.25,9,9,0,0,1,3.06-6.51c-1,1-3.16,4.8-.79,7.69,1.55,1.91,8.94,4.62,15,1.13A6.25,6.25,0,0,1,66,443.35a14,14,0,0,1-12.75,0A4.62,4.62,0,0,1,50.59,439.93Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,432.69c-.41.92.37,2.15,1.73,2.75s2.79.33,3.19-.59-.37-2.14-1.73-2.74S60.09,431.77,59.69,432.69Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.91,436.43a1.18,1.18,0,1,0,1.44-.4A1.06,1.06,0,0,0,64.91,436.43Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.91,442.87a3.67,3.67,0,0,0-7.34,0v.2a1.89,1.89,0,0,0,1.07,1.4,5.8,5.8,0,0,0,5.2,0,1.89,1.89,0,0,0,1.07-1.4v-.2Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.91,442.87a3.67,3.67,0,0,0-7.34,0v.2a1.89,1.89,0,0,0,1.07,1.4,5.8,5.8,0,0,0,5.2,0,1.89,1.89,0,0,0,1.07-1.4v-.2Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83,439.66h0a3.68,3.68,0,0,0-5.26,3.21v.2a1.89,1.89,0,0,0,1.07,1.4,5,5,0,0,0,1.85.57,1.85,1.85,0,0,1-1.28-2.4C67.55,441.28,68.93,439.31,70.83,439.66Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.91,443.07v-.2a3.65,3.65,0,0,0-1.25-2.65c.4.41,1.29,1.95.32,3.13-.63.77-3.64,1.88-6.11.46a2.56,2.56,0,0,0,.77.66,5.8,5.8,0,0,0,5.2,0A1.89,1.89,0,0,0,72.91,443.07Z",
    style: {
      fill: "#047D95",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,440.13c.17.37-.15.87-.7,1.11s-1.14.14-1.3-.23.15-.88.7-1.12S69,439.75,69.2,440.13Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,441.65a.49.49,0,0,1-.87.38.45.45,0,0,1,.28-.55A.44.44,0,0,1,67.08,441.65Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,426.19a3.67,3.67,0,0,1,7.34,0v.21a1.89,1.89,0,0,1-1.08,1.39,5.72,5.72,0,0,1-5.19,0A1.87,1.87,0,0,1,12,426.4v-.21Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,426.19a3.67,3.67,0,0,1,7.34,0v.21a1.89,1.89,0,0,1-1.08,1.39,5.72,5.72,0,0,1-5.19,0A1.87,1.87,0,0,1,12,426.4v-.21Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,423h0a3.66,3.66,0,0,1,5.26,3.2v.21a1.89,1.89,0,0,1-1.08,1.39,4.68,4.68,0,0,1-1.84.58,1.86,1.86,0,0,0,1.28-2.4C17.31,424.61,15.93,422.64,14,423Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,426.4v-.21a3.67,3.67,0,0,1,1.25-2.65c-.4.41-1.29,2-.33,3.13.64.78,3.65,1.88,6.12.46a2.48,2.48,0,0,1-.78.66,5.72,5.72,0,0,1-5.19,0A1.87,1.87,0,0,1,12,426.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66,423.45c-.17.38.15.88.7,1.12s1.14.14,1.3-.24-.15-.87-.7-1.12S15.82,423.08,15.66,423.45Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78,425a.45.45,0,0,0,.28.55.4.4,0,1,0,.31-.71A.45.45,0,0,0,17.78,425Z",
    style: {
      fill: "#fff",
      mixBlendMode: "lighten",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.38,348.63l-9.3-2.41-9.3,2.41a37.64,37.64,0,0,0,.11,12.78C61.1,369.22,66.54,377,69.08,377s8-7.8,9.2-15.61A37.77,37.77,0,0,0,78.38,348.63Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,348.63l-9.3-2.41-9.3,2.41a37.64,37.64,0,0,0,.11,12.78C61.1,369.22,66.54,377,69.08,377s8-7.8,9.2-15.61A37.77,37.77,0,0,0,78.38,348.63Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.17,349.75H62.44c-1.82,11,4,19.43,6.36,19.43S77,360.75,75.17,349.75Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,349.75H71a9.67,9.67,0,0,1,1.19,5.88c-.27,3-2.06,6.82-3.37,6.82s-3.1-3.86-3.36-6.82a9.71,9.71,0,0,1,1.18-5.88H68.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86,344.66h0l-1.45-15.55H53.16L51.7,344.66h0c-.3,2.74,1.35,5.54,5,7.64,6.71,3.87,17.59,3.87,24.29,0C84.63,350.2,86.27,347.4,86,344.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.73,336.14c-6.14-3.54-6.15-9.29,0-12.83s16.1-3.54,22.23,0,6.15,9.29,0,12.83S63.87,339.68,57.73,336.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63,340.85l-.49-5.21c-.45,2-2,3.95-4.67,5.49-6.42,3.7-16.82,3.7-23.25,0-2.67-1.54-4.22-3.48-4.67-5.49l-.49,5.21c.39,2.14,2,4.22,4.85,5.86,6.59,3.8,17.29,3.8,23.88,0C83.62,345.07,85.24,343,85.63,340.85Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.18,352.19l.47-.29h0a28.56,28.56,0,0,1-12.88,2.2c-7.81-.33-12.59-3.31-12.74-5.5a28.08,28.08,0,0,1,.34-5.4,28.45,28.45,0,0,0,12.72,2.56c8.75,0,14.06-3,16.45-5.79l-.24-2.6-.77-8.26H53.16L51.7,344.66h0a6.11,6.11,0,0,0,0,1.54q.06.33.15.66a7.47,7.47,0,0,0,.3.87,10.32,10.32,0,0,0,4.5,4.57,24.81,24.81,0,0,0,12.15,2.9,29.77,29.77,0,0,0,3.28-.18c.54-.06,1.08-.13,1.61-.22A22.06,22.06,0,0,0,81,352.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,339.87h-.45c-6.42.07-12.14-1.6-16.1-4.72a3.49,3.49,0,0,1,4.32-5.49c2.72,2.15,6.89,3.29,11.73,3.22h.1c4.85.05,9-1.07,11.73-3.22A3.5,3.5,0,0,1,85,335.15C81.08,338.2,75.53,339.87,69.29,339.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.67,320.66l2.63-32,10.64,6.14c5.1,2.95,7.39,10.5,6.55,21.64l-1.35,17.93-2.87-9.93c-1.56-5.41-5.54-7.27-11.27-5.28Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.67,320.66l2.63-32,10.64,6.14c5.1,2.95,7.39,10.5,6.55,21.64l-1.35,17.93-2.87-9.93c-1.56-5.41-5.54-7.27-11.27-5.28Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,320.66l-2.64-32L39.73,294.8c-5.11,2.95-7.39,10.5-6.55,21.64l1.34,17.93,2.87-9.93c1.56-5.41,5.54-7.27,11.28-5.28Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,320.66l-2.64-32L39.73,294.8c-5.11,2.95-7.39,10.5-6.55,21.64l1.34,17.93,2.87-9.93c1.56-5.41,5.54-7.27,11.28-5.28Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,263.45c0-34.18-14.44-63.71-25.18-70.55a2.9,2.9,0,0,0-.29-.19l0,0h0a4.12,4.12,0,0,0-4.15,0h0l-.05,0-.29.19c-10.73,6.84-25.17,36.37-25.17,70.55,0,32.89,9.21,62,10.09,64.75a1.18,1.18,0,0,1,.07.2h0a10.31,10.31,0,0,0,4.85,5.22c7,4,18.21,4,25.16,0,2.66-1.54,4.3-3.44,4.92-5.43C87.22,325.48,96.44,296.33,96.44,263.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.12,201.11a30.43,30.43,0,0,0-7.86-8.22L71,192.7l-.06,0h0a4.12,4.12,0,0,0-4.15,0h0a.09.09,0,0,1-.05,0l-.29.19a30.49,30.49,0,0,0-7.86,8.23,69.19,69.19,0,0,0-4.6,7.66,8.33,8.33,0,0,0,4.24,4.82c5.88,3.4,15.41,3.4,21.29,0a8.34,8.34,0,0,0,4.23-4.82A70,70,0,0,0,79.12,201.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,193.78l-1.43-14-1.43,14h0a.71.71,0,0,0,.42.58,2.25,2.25,0,0,0,2,0,.71.71,0,0,0,.42-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25,263.45c0,32.89,9.21,62,10.09,64.75a1.18,1.18,0,0,1,.07.2h0a10.31,10.31,0,0,0,4.85,5.22,20.46,20.46,0,0,0,3.87,1.68c-4.49-16.17-9.77-43.62-9.77-71,0-37.87,9.32-64.7,16.06-71.38C55.69,199.74,41.25,229.27,41.25,263.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,263.45c0,32.89-9.22,62-10.1,64.75,0,.06,0,.13-.07.2h0a10.26,10.26,0,0,1-4.85,5.22c5.21-19.06,11.16-41.94,11.16-69.34,0-37.87-14.58-64.7-21.32-71.38C82,199.74,96.44,229.27,96.44,263.45Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,310.34,86.8,293l-2.48,1.44L80,321.69,84.08,325A30.41,30.41,0,0,1,94.69,342.2l2.69,12.45s1.19-7.92,2.49-17.5C101,328.57,101,318.66,96.19,310.34Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,310.34,86.8,293l-2.48,1.44L80,321.69,84.08,325A30.41,30.41,0,0,1,94.69,342.2l2.69,12.45s1.19-7.92,2.49-17.5C101,328.57,101,318.66,96.19,310.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,321.69l4.31-27.23,9.39,17.32c4.8,8.32,5.73,17.9,4.94,27.47l-1.27,15.4L94.69,342.2A30.41,30.41,0,0,0,84.08,325Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,310.34,50.88,293l2.48,1.44,4.32,27.23L53.6,325A30.4,30.4,0,0,0,43,342.2l-2.7,12.45s-1.18-7.92-2.48-17.5C36.66,328.57,36.69,318.66,41.49,310.34Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,310.34,50.88,293l2.48,1.44,4.32,27.23L53.6,325A30.4,30.4,0,0,0,43,342.2l-2.7,12.45s-1.18-7.92-2.48-17.5C36.66,328.57,36.69,318.66,41.49,310.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.68,321.69l-4.32-27.23L44,311.78c-4.8,8.32-5.73,17.9-4.94,27.47l1.27,15.4L43,342.2A30.4,30.4,0,0,1,53.6,325Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,236.19A10.3,10.3,0,0,0,86,228.58l-1.7-1a8.22,8.22,0,0,0-4.11-1.07,9.9,9.9,0,0,0-3.18.55c-5.17,1.8-8.71,7.7-8.42,14,.2,4.33,2.26,7.91,5.24,9.67l1.79,1A8.35,8.35,0,0,0,79.75,253a8.6,8.6,0,0,0,2.81-.48C88.63,250.39,91.67,242.37,90.7,236.19Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7,236.19A10.3,10.3,0,0,0,86,228.58l-1.7-1a8.22,8.22,0,0,0-4.11-1.07,9.9,9.9,0,0,0-3.18.55c-5.17,1.8-8.71,7.7-8.42,14,.2,4.33,2.26,7.91,5.24,9.67l1.79,1A8.35,8.35,0,0,0,79.75,253a8.6,8.6,0,0,0,2.81-.48C88.63,250.39,91.67,242.37,90.7,236.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.75,253c-5.14,0-9.24-4.68-9.52-10.88s3.25-12.22,8.42-14a9.63,9.63,0,0,1,3.18-.55c4.56,0,8,3.41,8.87,8.69,1,6.18-2.07,14.2-8.14,16.28A8.6,8.6,0,0,1,79.75,253Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.59,249.65c-4.33,1.48-8.14-2.47-8.38-7.71s2.64-9.76,6.42-11.07,7.32.71,8.12,5.79S85.92,248.16,81.59,249.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,235.75a7.7,7.7,0,0,0-2.62-5,6.11,6.11,0,0,0-3.74.16c-3.78,1.31-6.66,5.82-6.42,11.07a9.09,9.09,0,0,0,3.23,6.86,5.33,5.33,0,0,0,3.39-.06C84.16,247.25,86.79,240.82,86,235.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.32,233c-3.54,1.78-5.18,6-4.5,9.8.05.31.18.68.48.75s.65-.28.83-.6c1-1.79,2.18-4,4.07-5a6.32,6.32,0,0,1,1.41-.47c1.33-.34,2.49-.91,2.59-2.46a2.24,2.24,0,0,0-1.75-2.53A4.56,4.56,0,0,0,79.32,233Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,266a7.9,7.9,0,0,0-3.63-5.83l-1.3-.74a6.19,6.19,0,0,0-3.14-.83,7.47,7.47,0,0,0-2.44.43c-4,1.37-6.67,5.89-6.45,10.73a9,9,0,0,0,4,7.41l1.37.79a6.38,6.38,0,0,0,3.19.86,6.69,6.69,0,0,0,2.15-.36C87.37,276.89,89.7,270.76,89,266Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89,266a7.9,7.9,0,0,0-3.63-5.83l-1.3-.74a6.19,6.19,0,0,0-3.14-.83,7.47,7.47,0,0,0-2.44.43c-4,1.37-6.67,5.89-6.45,10.73a9,9,0,0,0,4,7.41l1.37.79a6.38,6.38,0,0,0,3.19.86,6.69,6.69,0,0,0,2.15-.36C87.37,276.89,89.7,270.76,89,266Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M80.58,278.85c-3.94,0-7.07-3.58-7.29-8.32s2.49-9.36,6.45-10.73a7.46,7.46,0,0,1,2.43-.43c3.49,0,6.15,2.62,6.79,6.66.74,4.73-1.59,10.86-6.23,12.46A6.69,6.69,0,0,1,80.58,278.85Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,276.32c-3.32,1.14-6.23-1.88-6.42-5.9s2-7.46,4.92-8.46,5.6.54,6.21,4.42S85.3,275.19,82,276.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,265.69a5.91,5.91,0,0,0-2-3.86,4.63,4.63,0,0,0-2.86.13c-2.9,1-5.1,4.45-4.92,8.46A7,7,0,0,0,78,275.68a4.14,4.14,0,0,0,2.6-.05C84,274.49,86,269.57,85.35,265.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.25,263.61a7,7,0,0,0-3.45,7.5c0,.24.14.52.38.57s.49-.21.63-.46c.78-1.37,1.67-3,3.11-3.8a4.57,4.57,0,0,1,1.08-.36c1-.26,1.91-.69,2-1.88a1.72,1.72,0,0,0-1.34-1.94A3.5,3.5,0,0,0,80.25,263.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifier-glass--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifier-glass--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.7,337.53a.57.57,0,0,1,0-.13l3.16-69.1h0a3.86,3.86,0,0,1,2.33-3.21,12.36,12.36,0,0,1,11.23.16,4,4,0,0,1,2.33,3.29h0l3.13,69.18s0,.09,0,.13,0,.15,0,.23a10.93,10.93,0,0,1-11.1,11,11.3,11.3,0,0,1-11.09-11.29C330.69,337.67,330.7,337.61,330.7,337.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.42,265.25c3.11,1.84,3.1,4.76,0,6.51a12.41,12.41,0,0,1-11.24-.17c-3.1-1.84-3.1-4.75,0-6.5A12.36,12.36,0,0,1,347.42,265.25Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.89,334.77l-1.77-61.92a10.43,10.43,0,0,0,3.3-1.09,3.9,3.9,0,0,0,2.33-3.2l3.13,69.16s0,.09,0,.13,0,.15,0,.23a10.93,10.93,0,0,1-11.1,11C345.22,348.2,346.08,342.21,345.89,334.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.43,240a7.51,7.51,0,0,1,6.8.11,2.43,2.43,0,0,1,1.4,2h0l0,26.45h0a2.36,2.36,0,0,1-1.41,1.95,7.51,7.51,0,0,1-6.8-.1,2.46,2.46,0,0,1-1.4-2l0-26.45h0A2.36,2.36,0,0,1,338.43,240Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,257.29V246q-4.85,1.08-9.62,1.72V260.2C340,260.32,344.7,258.55,346.62,257.29Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,136.59,373.23,130c-8.69-5-20.71-4.29-34,3.36-26.55,15.34-48.07,52.61-48.07,83.27,0,15.34,5.38,26.1,14.09,31.13l11.44,6.54a24.71,24.71,0,0,0,12.53,3.2c6.45,0,13.75-2.11,21.46-6.57,26.55-15.32,48.08-52.6,48.08-83.26C398.77,152.39,393.39,141.62,384.71,136.59Zm-61.4,43.06c8.43-14.59,19.51-26.33,31.2-33.09,6.14-3.54,12.1-5.45,17.27-5.54a19.93,19.93,0,0,1,2.65.12c3.66,4.59,5.66,11.57,5.66,20.45,0,13.5-4.64,29-13.06,43.56s-19.5,26.34-31.2,33.08c-6.28,3.63-12.38,5.55-17.65,5.55a20.8,20.8,0,0,1-2.26-.13,20.6,20.6,0,0,1-1.81-2.71c-2.51-4.45-3.85-10.45-3.85-17.73C310.26,209.7,314.9,194.23,323.31,179.65Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.73,172l18.07,10.37c.49-.91,1-1.81,1.52-2.71a107.57,107.57,0,0,1,8.7-12.89L313.9,156.37A117.23,117.23,0,0,0,303.73,172Zm21.89-28.45q-3.36,3.08-6.49,6.56l18.21,10.45A85.81,85.81,0,0,1,344,154.1Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.64,254.29l-11.38-6.5c-8.71-5-14.09-15.79-14.09-31.13,0-.58,0-1.17,0-1.77l11.44,6.55q0,.88,0,1.77C302.62,238.49,308,249.25,316.64,254.29Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,148a16.17,16.17,0,0,0-11.63-6.9c3.66,4.59,5.66,11.57,5.66,20.45,0,13.5-4.64,29-13.06,43.56s-19.5,26.34-31.2,33.08c-6.28,3.63-12.38,5.55-17.65,5.55a20.8,20.8,0,0,1-2.26-.13,16.15,16.15,0,0,0,12.32,6.22q.48,0,1,0c5.26,0,11.37-1.92,17.65-5.55,11.69-6.75,22.77-18.5,31.2-33.08s13.05-30.06,13.05-43.57C391.13,159.32,389.34,152.62,386.06,148Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,148a16.17,16.17,0,0,0-11.63-6.9c3.66,4.59,5.66,11.57,5.66,20.45,0,13.5-4.64,29-13.06,43.56s-19.5,26.34-31.2,33.08c-6.28,3.63-12.38,5.55-17.65,5.55a20.8,20.8,0,0,1-2.26-.13,16.15,16.15,0,0,0,12.32,6.22q.48,0,1,0c5.26,0,11.37-1.92,17.65-5.55,11.69-6.75,22.77-18.5,31.2-33.08s13.05-30.06,13.05-43.57C391.13,159.32,389.34,152.62,386.06,148Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,140c-26.55,15.32-48.08,52.6-48.08,83.26S324.15,266.3,350.7,251s48.07-52.61,48.07-83.27S377.25,124.62,350.7,140Zm-3.82,104.4c-6.29,3.63-12.39,5.54-17.65,5.54a16.52,16.52,0,0,1-15.12-8.95c-2.51-4.45-3.85-10.45-3.85-17.73,0-13.51,4.63-29,13.06-43.56s19.5-26.33,31.19-33.09c6.13-3.54,12.1-5.45,17.27-5.54h.39c11.88,0,19,10,19,26.68,0,13.51-4.63,29-13.05,43.57S358.58,237.6,346.88,244.35Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.7,140c-26.55,15.32-48.08,52.6-48.08,83.26S324.15,266.3,350.7,251s48.07-52.61,48.07-83.27S377.25,124.62,350.7,140Zm-3.82,104.4c-6.29,3.63-12.39,5.54-17.65,5.54a16.52,16.52,0,0,1-15.12-8.95c-2.51-4.45-3.85-10.45-3.85-17.73,0-13.51,4.63-29,13.06-43.56s19.5-26.33,31.19-33.09c6.13-3.54,12.1-5.45,17.27-5.54h.39c11.88,0,19,10,19,26.68,0,13.51-4.63,29-13.05,43.57S358.58,237.6,346.88,244.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.28,180.24a111.29,111.29,0,0,0-9.76,27.31A77.68,77.68,0,0,0,302.89,222a53.4,53.4,0,0,0,1.57,14.36,31.82,31.82,0,0,0,6.38,12.81,23,23,0,0,0,12.07,7.46,30.12,30.12,0,0,0,14.34-.22A52.19,52.19,0,0,0,350.7,251a52.1,52.1,0,0,1-13.38,5.67,30.52,30.52,0,0,1-14.5.32,23.53,23.53,0,0,1-12.34-7.51,32.26,32.26,0,0,1-6.57-13,54.13,54.13,0,0,1-1.5-14.51,78.37,78.37,0,0,1,1.74-14.48,100,100,0,0,1,4.1-14A118,118,0,0,1,314.28,180.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.17,141a18.17,18.17,0,0,1,7.05,1.29,16.33,16.33,0,0,1,5.86,4.18,21.79,21.79,0,0,1,3.79,6.17,33.24,33.24,0,0,1,2,7,55.58,55.58,0,0,1,.4,14.46,79.07,79.07,0,0,1-2.68,14.22,95.2,95.2,0,0,1-5,13.59,111.55,111.55,0,0,1-6.79,12.78,99.44,99.44,0,0,1-18.44,22.25,70.38,70.38,0,0,1-11.83,8.43,40.79,40.79,0,0,1-13.71,4.95,22.1,22.1,0,0,1-7.39-.09,16.44,16.44,0,0,1-6.8-3,16.1,16.1,0,0,1-2.73-2.55,19.27,19.27,0,0,1-2.15-3,26.89,26.89,0,0,1-2.73-6.81,47.91,47.91,0,0,1-1.21-14.45,73.87,73.87,0,0,1,2.24-14.28,93.48,93.48,0,0,1,4.67-13.65,106,106,0,0,1,6.56-12.82,104.23,104.23,0,0,0-10.51,26.64,74.45,74.45,0,0,0-2,14.15,47,47,0,0,0,1.39,14.1,25.24,25.24,0,0,0,2.7,6.47,17,17,0,0,0,4.56,5.16,15.19,15.19,0,0,0,6.27,2.72,20.66,20.66,0,0,0,6.93,0,39.29,39.29,0,0,0,13.2-4.84,69.5,69.5,0,0,0,11.53-8.3A98.24,98.24,0,0,0,375.66,214a107.16,107.16,0,0,0,11.8-26,78.57,78.57,0,0,0,2.86-14,55.1,55.1,0,0,0-.19-14.23,31.26,31.26,0,0,0-1.8-6.88,21.12,21.12,0,0,0-3.55-6.13,16.13,16.13,0,0,0-5.65-4.23A18.08,18.08,0,0,0,372.17,141Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.7,141.83a18.27,18.27,0,0,0-5.54-.82h-.38c-5.17.09-11.13,2-17.27,5.54-11.69,6.76-22.77,18.5-31.2,33.09s-13.05,30-13.05,43.56c0,7.28,1.34,13.28,3.85,17.73a18.44,18.44,0,0,0,4.18,5.15,18.21,18.21,0,0,0,5.53.82c5.27,0,11.37-1.91,17.65-5.54,11.7-6.75,22.78-18.5,31.2-33.09s13.05-30.06,13.05-43.56C385.72,154.09,382.85,146.18,377.7,141.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.57,128l1-3.71c-.45-2.13,8.23,2.88,8.68,5l-2.8,7.53a1.14,1.14,0,0,1-.47.54c-.61.38-4.75,2.73-4.95,2.85a1.21,1.21,0,0,1-1.79-.66l-3.62-12.43C423.43,126.08,425.43,126.77,427.57,128Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57,128l1-3.71c-.45-2.13,8.23,2.88,8.68,5l-2.8,7.53a1.14,1.14,0,0,1-.47.54c-.61.38-4.75,2.73-4.95,2.85a1.21,1.21,0,0,1-1.79-.66l-3.62-12.43C423.43,126.08,425.43,126.77,427.57,128Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,76.32l33,19a2.48,2.48,0,0,1,1.11,1.94v39.1a2.43,2.43,0,0,1-1.12,1.92l-3.92,2.23a2.52,2.52,0,0,1-2.24,0l-33-19a2.46,2.46,0,0,1-1.12-1.93V80.46a2.44,2.44,0,0,1,1.13-1.92l3.92-2.23A2.49,2.49,0,0,1,417.66,76.32Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,76.32l33,19a2.48,2.48,0,0,1,1.11,1.94v39.1a2.43,2.43,0,0,1-1.12,1.92l-3.92,2.23a2.52,2.52,0,0,1-2.24,0l-33-19a2.46,2.46,0,0,1-1.12-1.93V80.46a2.44,2.44,0,0,1,1.13-1.92l3.92-2.23A2.49,2.49,0,0,1,417.66,76.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.49,79.81l33,19a2.47,2.47,0,0,1,1.11,1.93v39.1c0,.71-.5,1-1.11.65l-12.63-7.29-2.32,6.43a1.21,1.21,0,0,1-2.26-.11l-3.08-10.74-12.71-7.33a2.46,2.46,0,0,1-1.12-1.93V80.46C410.37,79.75,410.87,79.46,411.49,79.81Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.39,80.25c.09-.56.54-.76,1.1-.44l33,19a2.23,2.23,0,0,1,.78.83l6.15-3.53a2.2,2.2,0,0,0-.77-.8l-33-19a2.44,2.44,0,0,0-2.23,0l-3.92,2.22A2.46,2.46,0,0,0,410.39,80.25Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.39,80.25c.09-.56.54-.76,1.1-.44l33,19a2.23,2.23,0,0,1,.78.83l6.15-3.53a2.2,2.2,0,0,0-.77-.8l-33-19a2.44,2.44,0,0,0-2.23,0l-3.92,2.22A2.46,2.46,0,0,0,410.39,80.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.4,122.14l-.34,0a2.59,2.59,0,0,1-2-1.46l-4.14-8.72a2.58,2.58,0,0,1,4.66-2.2l2.45,5.13,11.83-13.78a2.58,2.58,0,1,1,3.91,3.36l-14.42,16.8A2.6,2.6,0,0,1,424.4,122.14Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.48,262.31l1-2.94c.5-2.38-9.19,3.22-9.7,5.6l3.13,8.4a1.34,1.34,0,0,0,.52.62c.69.42,3.21,1.84,3.43,2a1.36,1.36,0,0,0,2-.74l4-13.88C222.1,260.18,219.87,261,217.48,262.31Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.66,205.8l-36.85,21.26a2.74,2.74,0,0,0-1.25,2.16v43.66a2.72,2.72,0,0,0,1.25,2.15l2.28,1.29a2.79,2.79,0,0,0,2.5,0l36.85-21.25a2.77,2.77,0,0,0,1.25-2.16V209.22a2.72,2.72,0,0,0-1.25-2.14l-2.28-1.29A2.79,2.79,0,0,0,230.66,205.8Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,208.5l-36.85,21.26a2.75,2.75,0,0,0-1.25,2.16v43.66c0,.8.56,1.12,1.25.72l14.1-8.13,2.59,7.18a1.36,1.36,0,0,0,2.53-.12l3.44-12,14.19-8.18a2.77,2.77,0,0,0,1.25-2.16V209.22C236.69,208.43,236.13,208.1,235.44,208.5Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,208.5l-36.85,21.26a2.75,2.75,0,0,0-1.25,2.16v43.66c0,.8.56,1.12,1.25.72l14.1-8.13,2.59,7.18a1.36,1.36,0,0,0,2.53-.12l3.44-12,14.19-8.18a2.77,2.77,0,0,0,1.25-2.16V209.22C236.69,208.43,236.13,208.1,235.44,208.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.67,209c-.1-.63-.61-.86-1.23-.5l-36.85,21.26a2.63,2.63,0,0,0-.88.93L193,227.94a2.42,2.42,0,0,1,.86-.88l36.85-21.26a2.75,2.75,0,0,1,2.5,0l2.27,1.28A2.73,2.73,0,0,1,236.67,209Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bug--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.5,239.88l-.82-6.1a1.35,1.35,0,0,0-.86-1.09,1.25,1.25,0,0,0-.51-.1,1.4,1.4,0,0,0-.86.3L226.14,234a9.94,9.94,0,0,0-.86-1.86l1-2.28,1.38-4.81a1.39,1.39,0,0,0-.95-1.71,1.65,1.65,0,0,0-.38,0,1.39,1.39,0,0,0-1.33,1l-1.31,4.6-.45,1.06-.08-.06a5.12,5.12,0,0,0-1.87-.7l1.06-4.1a1.38,1.38,0,0,0-1-1.68,1.41,1.41,0,0,0-.35-.05,1.37,1.37,0,0,0-1.33,1l-1.29,5a8.52,8.52,0,0,0-1.41.6l-.44.26-.65-2.41a1.39,1.39,0,0,0-1.34-1,1.49,1.49,0,0,0-.36.05,1.38,1.38,0,0,0-1,1.69l1,3.57a19.6,19.6,0,0,0-3,3.93l-.82-2.55a1.38,1.38,0,0,0-1.32-1,1.52,1.52,0,0,0-.42.06,1.4,1.4,0,0,0-.89,1.74l1.14,3.55.78,1.21a28,28,0,0,0-1.51,4.75l-2.35.62a1.38,1.38,0,0,0-1,1.1l-1.23,7.2a1.38,1.38,0,0,0,1.13,1.59l.23,0a1.37,1.37,0,0,0,1.36-1.15l1.08-6.32.29-.08c-.06.6-.1,1.19-.12,1.78a17,17,0,0,0,.57,5.19l-2.33,2.82a1.37,1.37,0,0,0-.17,1.49l2.28,4.63a1.37,1.37,0,0,0,1.24.77,1.43,1.43,0,0,0,.61-.14,1.39,1.39,0,0,0,.63-1.85l-1.89-3.83.89-1.08a6.46,6.46,0,0,0,1.93,1.9,5.36,5.36,0,0,0,2.85.81,7.05,7.05,0,0,0,3.33-.91l.09-.06h0c3.22-1.78,6.12-5.94,7.81-10.71l.58.09-2.08,5.72a1.37,1.37,0,0,0,.82,1.77,1.27,1.27,0,0,0,.47.09,1.39,1.39,0,0,0,1.3-.91l2.66-7.29a1.38,1.38,0,0,0-1.08-1.83l-1.88-.31a25.08,25.08,0,0,0,.74-5.19,19.15,19.15,0,0,0-.11-2.77l.48-.39.49,3.67a1.39,1.39,0,0,0,1.37,1.19h.19a1.34,1.34,0,0,0,.91-.53A1.37,1.37,0,0,0,230.5,239.88Zm-8.45-7.42a14.38,14.38,0,0,1-5.36,5.89,5,5,0,0,1-2.31.67,2.55,2.55,0,0,1-1.48-.43,14.29,14.29,0,0,1,5.36-6.21,4.41,4.41,0,0,1,2-.58,2.61,2.61,0,0,1,1.39.39A3.18,3.18,0,0,1,222.05,232.46Zm-9.32,23.67c-1.66-1-2.57-3.81-2.46-7.46a24.24,24.24,0,0,1,1.51-7.51,5.4,5.4,0,0,0,2.57.63,6.5,6.5,0,0,0,1.55-.19l-.45,14.66a3.94,3.94,0,0,1-1.33.27A2.59,2.59,0,0,1,212.73,256.13Zm5.54-1.8.43-14a16.74,16.74,0,0,0,5-5.17,14.33,14.33,0,0,1,.49,4.46C224,245.21,221.49,251.16,218.27,254.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.12,258.64a4.69,4.69,0,0,1-2.51-.71c-2.33-1.45-3.59-4.85-3.46-9.33.24-7.52,4.24-15.47,9.11-18.08a6.44,6.44,0,0,1,3-.83,4.65,4.65,0,0,1,2.5.7c2.34,1.45,3.6,4.85,3.46,9.33-.23,7.4-4.31,15.52-9.1,18.09A6.44,6.44,0,0,1,214.12,258.64Zm6.17-27.49a5.08,5.08,0,0,0-2.34.66c-4.37,2.35-8.11,9.9-8.33,16.84-.12,3.88.91,6.89,2.77,8a3.17,3.17,0,0,0,1.73.49,4.93,4.93,0,0,0,2.33-.66c4.38-2.35,8.12-9.9,8.33-16.83.12-3.89-.91-6.89-2.76-8A3.28,3.28,0,0,0,220.29,231.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9,232.55a.66.66,0,0,1-.28-.05.75.75,0,0,1-.4-1l1.05-2.47,1.32-4.64a.74.74,0,0,1,.71-.53l.2,0a.74.74,0,0,1,.51.91l-1.38,4.78-1,2.51A.73.73,0,0,1,223.9,232.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.35,241.15a4.68,4.68,0,0,1-3.88-2,.74.74,0,0,1,.15-1,.77.77,0,0,1,.44-.14.73.73,0,0,1,.59.3,3.29,3.29,0,0,0,2.73,1.39,5.71,5.71,0,0,0,2.62-.75,15.88,15.88,0,0,0,6.23-7.4.74.74,0,0,1,.67-.43.73.73,0,0,1,.3.06.75.75,0,0,1,.39.41.73.73,0,0,1,0,.56,17,17,0,0,1-6.88,8.09A7.1,7.1,0,0,1,214.35,241.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.79,257.89a.7.7,0,0,1-.53-.23.72.72,0,0,1-.19-.52l.54-17.6a.73.73,0,0,1,.75-.71.76.76,0,0,1,.52.23.71.71,0,0,1,.2.53l-.55,17.59a.73.73,0,0,1-.73.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,231l-.19,0a.75.75,0,0,1-.53-.9l1.45-5.61A.74.74,0,0,1,221,224l.19,0a.74.74,0,0,1,.53.9l-1.45,5.61A.75.75,0,0,1,219.54,231Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.06,239.45a.75.75,0,0,1-.62-.34l-1-1.54-1.11-3.46a.73.73,0,0,1,.48-.92.85.85,0,0,1,.22,0,.74.74,0,0,1,.7.51l1.05,3.27.89,1.38a.75.75,0,0,1,.11.56.8.8,0,0,1-.32.46A.72.72,0,0,1,211.06,239.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.66,233.12a.72.72,0,0,1-.7-.54l-1.15-4.23a.74.74,0,0,1,.52-.9.62.62,0,0,1,.19,0,.73.73,0,0,1,.71.54l1.14,4.22a.73.73,0,0,1-.51.9A.69.69,0,0,1,215.66,233.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,240.8a.73.73,0,0,1-.72-.64l-.65-4.8-1.58,1.27a.73.73,0,0,1-1-.11.74.74,0,0,1,.12-1l2.59-2.09a.73.73,0,0,1,.46-.17.67.67,0,0,1,.28.06.72.72,0,0,1,.45.58l.82,6.1a.72.72,0,0,1-.63.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,254.62a.74.74,0,0,1-.25-.05.73.73,0,0,1-.44-.94l2.35-6.45-1.79-.29a.74.74,0,0,1,.12-1.46h.12l2.67.43a.75.75,0,0,1,.57,1l-2.66,7.29A.74.74,0,0,1,225.16,254.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9,253.7h-.13a.74.74,0,0,1-.59-.85l1.23-7.19a.73.73,0,0,1,.53-.59l2.56-.67a.58.58,0,0,1,.19,0,.73.73,0,0,1,.18,1.44l-2.09.55-1.16,6.73A.72.72,0,0,1,204.9,253.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,262.84a.74.74,0,0,1-.66-.41l-2.29-4.64a.73.73,0,0,1,.1-.79l2.37-2.87a.74.74,0,0,1,.57-.27.75.75,0,0,1,.47.17.77.77,0,0,1,.26.5.71.71,0,0,1-.17.54l-2.07,2.5,2.08,4.21a.73.73,0,0,1-.33,1A.8.8,0,0,1,209.1,262.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.7,233.92a.39.39,0,0,0-.24-.31.4.4,0,0,0-.15,0,.38.38,0,0,0-.24.09l-2.48,2a9.5,9.5,0,0,0-1.43-3.49l.09-.2h0l1.05-2.49,1.36-4.75a.39.39,0,0,0-.26-.48l-.11,0a.39.39,0,0,0-.37.28l-1.33,4.66-1,2.34a5.13,5.13,0,0,0-1-.82,4.29,4.29,0,0,0-2.32-.66l-.29,0,1.36-5.26a.38.38,0,0,0-.28-.47H221a.38.38,0,0,0-.37.29l-1.44,5.57a7.2,7.2,0,0,0-1.75.65,10.66,10.66,0,0,0-1.5,1l-1-3.77a.4.4,0,0,0-.38-.29l-.1,0a.38.38,0,0,0-.27.47l1.11,4.12a19.55,19.55,0,0,0-4.12,5.76l-.67-1-1.07-3.33a.39.39,0,0,0-.37-.27l-.12,0a.39.39,0,0,0-.25.49l1.11,3.42,1,1.49h0v0a27.1,27.1,0,0,0-1.83,5.85.37.37,0,0,0-.24-.1l-.1,0-2.56.67a.4.4,0,0,0-.28.31l-1.23,7.19a.39.39,0,0,0,.31.45h.07a.39.39,0,0,0,.38-.33l1.19-6.95,2.31-.61h0a22.42,22.42,0,0,0-.32,3.15,15.1,15.1,0,0,0,.76,5.61h-.07a.37.37,0,0,0-.3.14l-2.37,2.87a.38.38,0,0,0-.05.42l2.28,4.63a.4.4,0,0,0,.35.22.47.47,0,0,0,.17,0,.4.4,0,0,0,.18-.52l-2.18-4.41,2.22-2.67a0,0,0,0,1,0,0,6.12,6.12,0,0,0,2.3,2.82,4.37,4.37,0,0,0,2.32.65,6.09,6.09,0,0,0,2.83-.77h0c3.3-1.77,6.25-6.23,7.79-11.25a.61.61,0,0,0,.07.14.37.37,0,0,0,.25.15l2.21.37-2.5,6.84a.4.4,0,0,0,.23.5l.13,0a.4.4,0,0,0,.37-.25l2.65-7.29a.38.38,0,0,0,0-.33.39.39,0,0,0-.27-.18l-2.66-.44h-.07a.4.4,0,0,0-.26.1,24.78,24.78,0,0,0,1-6.17,17.9,17.9,0,0,0-.17-3.26.45.45,0,0,0,.23-.09L228,234.7l.73,5.42a.38.38,0,0,0,.38.33h.05a.4.4,0,0,0,.26-.15.43.43,0,0,0,.08-.29Zm-10.91-2.41a5.22,5.22,0,0,1,2.5-.7,3.56,3.56,0,0,1,1.91.54,4.4,4.4,0,0,1,1.06.93,15.88,15.88,0,0,1-6.1,6.95,5.93,5.93,0,0,1-2.78.78,3.59,3.59,0,0,1-2.7-1.15C213.25,235.52,215.43,232.77,217.79,231.51ZM212.2,257c-2-1.21-3-4.33-2.92-8.34a25.39,25.39,0,0,1,2.06-9,4.28,4.28,0,0,0,3,1.19,6.42,6.42,0,0,0,2.59-.61l-.52,16.72a5.14,5.14,0,0,1-2.3.61A3.59,3.59,0,0,1,212.2,257Zm12.93-17.29c-.21,6.73-3.71,14-7.92,16.78l.52-16.68a16.24,16.24,0,0,0,6-6.8A12.43,12.43,0,0,1,225.13,239.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.93,364.2c0,10.09.77,18.9-.18,25.33-.07.54,5.33,2.65,9,2s4.67-1.92,4.67-2.31c0-1.35,1.34-3.14,1.48-4.48.88-8.46,2.15-14.52,2.79-20.54Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.28,407.31c-.25,0-.58,2.7.81,3.82,1.6,1.29,6.27,3.38,12.36,2.51s7.77-2.09,10.18-4.11,4.6-4.15,7.35-4.79c2.55-.59,6.44-1.65,7.24-2.44s.62-4.2.62-4.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.19,383.3a1.1,1.1,0,0,1,1.05.8c.21.94.47,3.68.9,5.22a37.65,37.65,0,0,1,.61,10c-.3,1.76-5.58,2.93-8.23,4a25.29,25.29,0,0,0-7.38,4.71,19,19,0,0,1-11.2,4.2c-4.71,0-10.05-1.34-11.31-3.44-1.56-2.6-1.83-5.11,5.09-8.37,1.31-.61,5.33-3,6.89-4a29.53,29.53,0,0,0,4.79-3.67,24.92,24.92,0,0,0,1.75-1.81,5.66,5.66,0,0,0,.93-1.93,26.69,26.69,0,0,0,.37-3.91.66.66,0,0,1,.12-.33.6.6,0,0,1,.3-.19,8.57,8.57,0,0,1,3.42-.23,14.08,14.08,0,0,1,3.46.7,3,3,0,0,1,1.61.95,2.31,2.31,0,0,1,.33,1.26,9.5,9.5,0,0,0,.07,1.31.74.74,0,0,0,.19.43c.24.23.61,0,.81-.14a17.87,17.87,0,0,0,1.84-2.23c.32-.4,1.8-.68,2.21-1a12,12,0,0,0,1.18-.77C421.4,384.37,421.18,383.85,421.19,383.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.14,408a34.29,34.29,0,0,1,3.19-2.46h0s-7.39,3-10.75.84c-2.17-1.38-1.19-3.12-1.15-3.67s-5.28-2.82-7.36-3h0c-.57.32-1.05.58-1.35.72-6.92,3.26-6.65,5.77-5.09,8.37,1.26,2.1,5.14,3.69,11.22,3.59A19.65,19.65,0,0,0,408.14,408Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,401c-4.3,1.76-2.43,2.52-1.22,2.66s7.28-3.38,11.67-6.87c4.57-3.65,8.54-7.49,10.24-8.83a25.23,25.23,0,0,0,1.92-1.69c-.13-.92-.24-1.77-.34-2.21-.18-.79-1.15-1-1.15-1l-.17,1.65a3.21,3.21,0,0,1-1.19.69,5.63,5.63,0,0,0-2.13,1.12,17.87,17.87,0,0,1-1.84,2.23C412.07,393.52,404.28,399.28,400,401Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.05,403.08a.39.39,0,0,0,.27-.1.41.41,0,0,0,.05-.59,10.58,10.58,0,0,0-8-2.91.42.42,0,1,0,.11.83,9.73,9.73,0,0,1,7.25,2.62A.46.46,0,0,0,399.05,403.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8,400.94a.44.44,0,0,0,.27-.09.41.41,0,0,0,.07-.59,10.55,10.55,0,0,0-7.95-3.09.42.42,0,0,0-.38.46.42.42,0,0,0,.47.37,9.78,9.78,0,0,1,7.19,2.79A.43.43,0,0,0,402.8,400.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.26,398.52a.41.41,0,0,0,.27-.1.4.4,0,0,0,.05-.58,10.51,10.51,0,0,0-8-2.91.4.4,0,0,0-.37.46.42.42,0,0,0,.48.36,9.75,9.75,0,0,1,7.25,2.63A.48.48,0,0,0,406.26,398.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,396.34a.46.46,0,0,0,.27-.09.42.42,0,0,0,.08-.59,10.55,10.55,0,0,0-7.89-3.23.41.41,0,0,0-.39.45.43.43,0,0,0,.46.38,9.75,9.75,0,0,1,7.14,2.92A.46.46,0,0,0,409.31,396.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,393.77a.46.46,0,0,0,.27-.09.41.41,0,0,0,.08-.58c-1.65-2.1-5.43-3.54-8.63-3.26a.41.41,0,0,0-.39.45.43.43,0,0,0,.46.38c2.88-.25,6.41,1.07,7.87,2.93A.47.47,0,0,0,412.59,393.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.35,367.57l-18.5-.85,4.46,23,1.26,5.62c.61,4.08,10.26,5.17,12.6-1.15l-.08-5.52C461.16,383.59,461.22,375.15,461.35,367.57Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.32,417.28c.05,4.18.56,7,1.92,9.49s4.11,3.42,7,2.84,6.57-2.32,7.56-5.87a22.91,22.91,0,0,0,.48-9.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.09,388.67c1,.36.94,6.08,1.34,11.71.43,6,1.4,7.91,1.8,12.86.47,5.66,0,7.53-2.15,10.83s-9.28,6.31-12.48,1.27c-2.62-4.1-2.45-7.88-1.92-13.48a117.33,117.33,0,0,0,.6-13.39c0-4.22-2-8.33-1-8.75a16.12,16.12,0,0,0,.54,3.19,5.23,5.23,0,0,0,.53,1.59c.51.81.84-.46.86-.94,0-.83-.2-1.51.48-2.17a4.92,4.92,0,0,1,1.79-.92,11.2,11.2,0,0,1,2.15-.5,21.83,21.83,0,0,1,4.5,0,2.16,2.16,0,0,1,1.7.81,1.13,1.13,0,0,1,.14.45c.09.55,0,1.12.08,1.67,0,.16.07.56.21.66s.39.07.4,0S461.15,389.65,461.09,388.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.09,411.31c.07.81.39,5.91-1.12,6.81s-2.3-3.3-2.3-3.3-3.66-1.32-9.18.79c.23.88-.74,3.72-2.19,3s-1.66-6.23-1.67-6.31c-.48,5.38-.57,9,2,13,3.2,5,10.34,2,12.48-1.27s2.62-5.17,2.15-10.83C464.19,412.68,464.16,411.82,464.09,411.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.23,415.16c-.08,2,1.77,1.42,2.19-1.42.62-4.27-.25-8.42,0-13.36-.4-5.63-.18-11.56-1.34-11.71,0,1-.4,4.82-.4,4.82.16,4.21,1,9.17.65,13.48C461,410.77,460.3,413.13,460.23,415.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.12,415.58c-.29-2-.91-2.61-1.13-6.42s-2-10.69-2.57-14.83c-.16-1.28-1.11-4.57-1.11-4.61-.75.31-.17,2.7.28,5.26s.76,4.14,1,6.59c.76,4.89.66,10,1.18,12.87S452.4,417.6,452.12,415.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.65,415.66a.42.42,0,0,0,.16,0,13.74,13.74,0,0,1,9-.5.43.43,0,0,0,.55-.28.44.44,0,0,0-.28-.54,14.41,14.41,0,0,0-9.64.54.43.43,0,0,0,.2.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.67,411.56a.4.4,0,0,0,.15,0c.05,0,5.34-2.15,10.52-.68a.43.43,0,0,0,.53-.3.43.43,0,0,0-.29-.53,18.92,18.92,0,0,0-11.1.71.44.44,0,0,0-.23.57A.43.43,0,0,0,450.67,411.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.1,407.58a.44.44,0,0,0,.13-.84c-5.13-2-12.11.09-12.33.2a.42.42,0,0,0-.21.57.43.43,0,0,0,.57.21c.05,0,6.88-2.06,11.65-.17A.63.63,0,0,0,462.1,407.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.43,403.89a.43.43,0,0,0,.14-.83c-5.64-2.33-11.69.53-11.9.64a.43.43,0,0,0,.41.76c.05,0,5.91-2.77,11.16-.6A.63.63,0,0,0,461.43,403.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.29,399.43a.42.42,0,0,0,.37-.26.43.43,0,0,0-.22-.57c-5.29-2.27-11.76.64-12,.76a.43.43,0,0,0,.4.77s6.34-2.85,11.24-.73A.46.46,0,0,0,461.29,399.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.12,307.7l-2.86,22.14s.25,7.59-.11,14.9-3.52,24.73-5.12,32.5a16.17,16.17,0,0,1-16,.15s-1.59-38.71-2.24-49,.89-51.91,1.39-68.2l49.93.15s1,8.76,1.88,21.85,2.92,48.15,2.92,48.15c4.71,15.83,3,23.36,1.75,50.29-7.6,5.33-16.7.83-16.7.83s-4.54-22.79-7.18-34.47-4.71-26.56-7.64-39.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.64,285.62l-1.44,20c-.09,3.19-.8,10.17-.86,13.36s-.3,7.58-.26,13.14.07,21.39-.18,27.79c-.95-7.09-1-23-1-31.34s.58-13.77,1.43-23S410.83,292,411.64,285.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.91,285.25c1.86,12.66,4.58,35.23,5.51,42.47s4.66,30.67,5.37,38c-1.28-7.23-5.83-30.49-6.84-37.78S439.57,299.11,438.91,285.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.15,284.65l4,23.05-2.86,22.14.7-21.21-4.64-21.69s-8.73-2.58-11-11.46C416.77,282.62,426.15,284.65,426.15,284.65Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.6,226.67c2,1.48,4.13,3.83,7.56,6.47s8.67,7.29,13.63,10,7.4,3.82,13.26-2.65a168,168,0,0,0,14.65-19.64l-.84-23.21c-5.06,1.7-7.91,4.53-10.91,9.46-5.67,9.29-9.51,15.29-12.79,20.65,0,0-14.59-8-16.49-9.25a7.64,7.64,0,0,1-3.06-4,36.5,36.5,0,0,0-1.57-4c-.62-1.39-.86-1.92-1.58-3.67s-1.31-4.71-1.55-5.36c-.43-.73-1.54-.63-2.43,1.21a7.17,7.17,0,0,0-.32,3.59c.09,1.08.45,2.39.12,2.58s-1.88-.56-3.44-.89-2.95-1-4.66-.4a2,2,0,0,0-1.33,2.72,2.62,2.62,0,0,0,.94,1,2.2,2.2,0,0,0-1.64.55,2.37,2.37,0,0,0,0,3,1.36,1.36,0,0,0-1.29,1.22c-.16,1,0,2,1,2.4,0,0-.84.22-.88.71a2.42,2.42,0,0,0,.85,2.22,7.83,7.83,0,0,0,2.93.61s.16.37,1.14.84a24.23,24.23,0,0,0,3.29,1.67C360.52,225,363,225.49,364.6,226.67Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.16,227.77a11.31,11.31,0,0,1,5.1,7.33,8.65,8.65,0,0,0-4.48-8.35Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.86,197.55a16.13,16.13,0,0,0-7.45,4.66c-2.08,2.22-5.74,8.48-7.93,11.95s-4.53,7.15-4.53,7.15.17,8.81,11.43,13.17l9.71-13.36Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,219.58a.9.9,0,0,1-.19.74,7,7,0,0,1-.71.74,3.17,3.17,0,0,1-.39.34,1.52,1.52,0,0,1-.42.23l-1,.39a3.61,3.61,0,0,0,1.08-.11,1.42,1.42,0,0,0,.54-.23,4.7,4.7,0,0,0,.44-.34,5,5,0,0,0,.7-.87,1.37,1.37,0,0,0,.14-.57.93.93,0,0,0-.13-.34,4.79,4.79,0,0,0,.8-.33,2.59,2.59,0,0,0,1.12-.82,2.11,2.11,0,0,0,.22-.67.89.89,0,0,0,0-.23l.3-.46a6.11,6.11,0,0,0,1.51,2.4,7.27,7.27,0,0,0,3,1.83,6.36,6.36,0,0,1-2.6-2.38,6.44,6.44,0,0,1-.54-5.22l.08,0a.9.9,0,0,0,.31-.41,1.28,1.28,0,0,0,0-1,2.52,2.52,0,0,0-.45-.78,5,5,0,0,0-3-1.6,2.27,2.27,0,0,0-.44-.61,3.68,3.68,0,0,0-.6-.51,7.07,7.07,0,0,1,.54.56,2.69,2.69,0,0,1,.38.65v0h0a5.18,5.18,0,0,1,2.76,1.67,1.45,1.45,0,0,1,.37,1.37c-.13.25-.22.32-.49.29s-.54-.08-.82-.11c-.58-.07-1.14-.07-1.69-.12a6.76,6.76,0,0,1-1.6-.37c-.52-.19-1-.44-1.53-.68a12.45,12.45,0,0,1-1.48-.8A14,14,0,0,0,356.7,213a5.6,5.6,0,0,0,1.66.45c.57.07,1.14.07,1.68.15l.33.05a1,1,0,0,1,.38.65,1.14,1.14,0,0,1-.55,1.13,6.78,6.78,0,0,1-1.21.72,3.81,3.81,0,0,1-1.32.35,9.69,9.69,0,0,1-2.72-.77c-.91-.31-1.83-.63-2.76-.9.87.42,1.76.81,2.65,1.18.45.2.9.37,1.36.54a4.2,4.2,0,0,0,1.47.32,3.88,3.88,0,0,0,.91-.2,1.42,1.42,0,0,1,.77.47.64.64,0,0,1,.13.53,2,2,0,0,1-.22.56,2.86,2.86,0,0,1-1,.66,2.74,2.74,0,0,1-1.16.34,4.91,4.91,0,0,1-1.22-.34,8.6,8.6,0,0,0-1.31-.24c-.88-.1-1.75-.17-2.63-.2.86.18,1.73.33,2.58.49a12.2,12.2,0,0,1,1.26.28,4.48,4.48,0,0,0,1.31.38A1.68,1.68,0,0,0,357.51,219.58Zm3.06-5.85,0,0h0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-3",
    d: "M439.35,194.88c7.75,1.7,10.08,2.45,13.75,3.29,0,0,7.6,7,3.13,32.22A107.73,107.73,0,0,0,455,249c.12,5.6,1,14.15,1.14,18,0,0-9.29,6-30.94,3.93-17-1.61-20.73-8-20.73-8V226.75c0-20.7,3.7-25.51,8.32-29.18.61-.37,12.11-2.29,12.11-2.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.9,153.42c8.27-2,14.17,1.2,17.67,5.49,3.5,0,5.52,2.75,6.07,6.18,1.86,11.58-7.37,17.77-8.74,23.48l-25.65-20C411.7,164.48,412,156,422.9,153.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,157.11,440.29,159a2.62,2.62,0,0,0,3.33,1.31A2.34,2.34,0,0,0,444.86,157.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92,154.27l-.63,4.8a2.59,2.59,0,0,0,2.83-2.17A2.36,2.36,0,0,0,440.92,154.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.59,163a6.11,6.11,0,0,0,1.27,2.08c1,1.15,2.63,1.7,3.57,2.9s.38,2.61.58,4.05a3.14,3.14,0,0,0,1.36,2.31c2.08,1.2,3-1.92,4.33-2.87a3.87,3.87,0,0,1,6,1.22,7.42,7.42,0,0,1-1.86,8.78,3.78,3.78,0,0,1-4.93-.12l1.21,14.7c-2.19,4.24-8,7.45-13.88,7.2s-4.64-3.26-2.64-5.62l-.45-5.09a17,17,0,0,1-4.86-.3c-3.63-.88-5.52-3.66-6.61-7.43-1.32-4.59-.57-9.36-.44-13.43.06-1.82-.33-5.37.82-8s3.85-1.79,6.45-2.82c3-1.17,6.43-1.67,9.35-.35a1,1,0,0,1,.38.26,1.18,1.18,0,0,1,.13.83A4.53,4.53,0,0,0,428.59,163Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.52 170.13 420.51 179.72 415.7 177.96 421.52 170.13",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5,181.46l-4.95,1.91a2.62,2.62,0,0,0,3.4,1.55A2.7,2.7,0,0,0,425.5,181.46Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,184.92c-.1,0-.21.06-.31.09a2.37,2.37,0,0,1,2-2.64A2.69,2.69,0,0,1,424,184.92Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,167.74l3.47,1.6a2,2,0,0,0-.95-2.56A1.89,1.89,0,0,0,425.66,167.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.48,172.75a1.55,1.55,0,1,1-1.55-1.55A1.56,1.56,0,0,1,427.48,172.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.22,172.75a1.55,1.55,0,1,1-1.55-1.55A1.55,1.55,0,0,1,416.22,172.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.11,192.53a32.34,32.34,0,0,0,7.65-1.74c2.91-1.25,4.16-2.21,5.51-5.66a8.15,8.15,0,0,1-2,5.06c-3.33,3.36-11,4-11,4Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.85,162.76a2.17,2.17,0,0,0-.63.34,6.73,6.73,0,0,0-1.08,1.18,12.05,12.05,0,0,1-5.15,4.36,8.14,8.14,0,0,1-4,.3,3.08,3.08,0,0,0,2.06-2.22,7.4,7.4,0,0,1-5.38,1.52,3.57,3.57,0,0,1-2.28-1.42,2.51,2.51,0,0,1-.15-2.61,4.56,4.56,0,0,0-1.54,2.64c-1.36-1.12-1.46-3.31-1-4.88a8,8,0,0,1,3.11-4.15,3.6,3.6,0,0,1-1.73-4c0-.09.07-.19.16-.22s.19,0,.27.07c2.5,1.48,5,.18,7.36-.92A24.41,24.41,0,0,1,427,150.3c5.12-.26,13.61,2,13.75,8.54,0-.42-5.81,1.25-6.3,1.5-.72.36-1.25,1-2,1.34s-2.11,1.22-3,1.06A3.16,3.16,0,0,0,427.85,162.76Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.43,230.5h0l1.22-1.13h0a1.4,1.4,0,0,1,1.29-.19l37.42,8.66a5,5,0,0,1,3.18,2.74l10.93,27.88a1.29,1.29,0,0,1-.13,1.45h0l-1.26,1.17v0a1.41,1.41,0,0,1-1.3.21l-37.42-8.66a5,5,0,0,1-3.18-2.74L383.24,232C383,231.31,383.07,230.78,383.43,230.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.63,239.71a4.9,4.9,0,0,1,1.66,2l10.94,27.87a1.37,1.37,0,0,1-.08,1.42l1.17-1.09v0a1.28,1.28,0,0,0,.13-1.45l-10.93-27.88a4.83,4.83,0,0,0-1.54-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,269.6l-10.93-27.88a5.05,5.05,0,0,0-3.17-2.74l-37.43-8.66c-1.28-.29-1.92.46-1.45,1.68l10.93,27.88a5,5,0,0,0,3.18,2.74l37.42,8.66C436.05,271.57,436.7,270.82,436.22,269.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.51,247.65l-2-5.22a1,1,0,0,0-.6-.51l-2.57-.59c-.24-.05-.36.09-.27.31l2,5.22a.93.93,0,0,0,.59.51l2.58.6C425.48,248,425.6,247.88,425.51,247.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.39,243.7a2.36,2.36,0,0,0-1.51-1.26c-.62-.14-.94.2-.72.75a2.34,2.34,0,0,0,1.51,1.26C423.29,244.59,423.61,244.26,423.39,243.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.39,246.34a2.34,2.34,0,0,0-1.51-1.26c-.62-.14-.94.19-.72.75a2.36,2.36,0,0,0,1.51,1.26C424.28,247.23,424.61,246.89,424.39,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,253.15l.59,1.49a37,37,0,0,1-6.48,1.05c-.74,0-3.51-1.3-5.77-1.89s-3.73.77-2.55,1.68a14.43,14.43,0,0,0,2,1.37c-.95.94-1.61,1.83.3,3.44a2.55,2.55,0,0,0,.81,2.82,24.23,24.23,0,0,0,6.38,4c1.25.48,7.72.06,8.26-.24a39.29,39.29,0,0,0,4.92-3.44,36.65,36.65,0,0,1,6.55-3.62c2-.66,19.53-7.92,22.63-9.5s8.1-5,3.9-8.28-10.66-5.28-15.72-2c-3.67,2.38-13,7.53-17.1,10a5.16,5.16,0,0,1-3.74.77,27.73,27.73,0,0,0-5.84.09Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,198.56c8,2.3,10.47,3.73,12.12,8.08,2.67,7.07,8.79,31.28,9.13,37.6.17,3.12-14.83,3.63-14.83,3.63l-2.5-7.82s-5.17-17.66-6.35-21.4C449.53,214.44,448,202.64,453.3,198.56Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.22,240.05c2.68-1.75,7.72-2,10.47-.82-2-2.54-8-2.12-10.83-.28Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.19,256.85c.91.52,1.8,1.09,2.69,1.66.45.28.88.58,1.32.87a1.11,1.11,0,0,0,.61.27l.76.08c2.07.15,4.18.15,6.28.32-1.05.1-2.1.16-3.15.19a30.48,30.48,0,0,1-3.17,0l-.8-.1a2,2,0,0,1-.45-.13,2.78,2.78,0,0,1-.36-.24c-.42-.31-.85-.61-1.26-.93C420.82,258.17,420,257.53,419.19,256.85Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.49,260.29c.87.6,1.74,1.18,2.63,1.73.45.27.89.55,1.35.81.22.12.45.26.67.37a3.05,3.05,0,0,0,.69.16c1,.13,2.08.15,3.12.21s2.1.08,3.15.2a35.2,35.2,0,0,1-6.33.05,3.23,3.23,0,0,1-.84-.21l-.69-.4c-.45-.28-.9-.57-1.32-.89A19.66,19.66,0,0,1,419.49,260.29Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,264.48c.71.29,1.41.6,2.12.85a10.26,10.26,0,0,0,2.17.53,15.25,15.25,0,0,0,2.25.05,12.69,12.69,0,0,1,2.3.14l-2.28.26a9.55,9.55,0,0,1-2.33,0A9.76,9.76,0,0,1,422,264.48Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.1,198.17c6.74,1.69,7.95,2.65,10.17,4.49s3.12,5,4.71,10.75,4.52,17.51,4.52,17.51a13.91,13.91,0,0,1-7.76,4,19.87,19.87,0,0,1-9.42-.44s-4.71-14.83-5.53-17.5S447.05,201.66,453.1,198.17Z",
    style: {
      fill: "#047D95"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.37,426.36l7-12.38L272,422.12l-16.79,18.14s-7.88-1.08-9-5.27S250.13,427.64,252.37,426.36Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,430.94a6.48,6.48,0,0,0-1.88,1.88c-.56.75-.56,4.51-1.14,6.23s-1,2.16-1.91,4.31c-1,2.37-2.83,4.51-1.17,10.81s4.6,9.39,7.14,11a7,7,0,0,0,3.11.9s3.47-1.14,3-3.19S243,430.94,243,430.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,438.42a7.5,7.5,0,0,1-1.45,2.08,17,17,0,0,0-2.48,6.12c-2.45,9.75,1.24,14.92-4.22,18.37-1.57.9-4.74.49-9.3-5.92-2.33-3.27-3.46-9.84-2.36-12.75s2.49-4.77,3.21-7,.59-6.48,1.93-8.37a9.19,9.19,0,0,1,3.18-2.51c1-.53,3.05-1.19,4-1.69s1.54-1.1,2.12-.38l-1.16,1.32c-1.83,2.31-1.37,2.68-1.38,4a20.21,20.21,0,0,1-.82,4c1.3-1.5,1.86-2.83,3.19-2.53s1.49.24,3.33,2.12S257.82,437.85,257.71,438.42Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,438.42a7.5,7.5,0,0,1-1.45,2.08,17,17,0,0,0-2.48,6.12c-2.45,9.75,1.24,14.92-4.22,18.37-1.57.9-4.74.49-9.3-5.92-2.33-3.27-3.46-9.84-2.36-12.75s2.49-4.77,3.21-7,.59-6.48,1.93-8.37a9.19,9.19,0,0,1,3.18-2.51c1-.53,3.05-1.19,4-1.69s1.54-1.1,2.12-.38l-1.16,1.32c-1.83,2.31-1.37,2.68-1.38,4a20.21,20.21,0,0,1-.82,4c1.3-1.5,1.86-2.83,3.19-2.53s1.49.24,3.33,2.12S257.82,437.85,257.71,438.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.26,459.07c-2.33-3.27-3.46-9.84-2.36-12.75a26.69,26.69,0,0,1,1.26-2.81c0,.2-.12.4-.16.57-.07.38-.14.76-.19,1.14a8.77,8.77,0,0,0,.29,4.49c.5,1.25,1.65,4.38,3.3,4.52.94.08,1.77-.8,2.18-1.83.17-.44.47-1.62.47-1.62a14.59,14.59,0,0,1,4.23,1.94c2.33,1.7,2.22,2,2.22,2a6.58,6.58,0,0,0-.17,2.11,5.23,5.23,0,0,0,.8,2.13,3.49,3.49,0,0,0,.59.52,6.4,6.4,0,0,1-3.16,5.47C248,465.89,244.82,465.48,240.26,459.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.78,446.62a33,33,0,0,0-1,7.83c-1,2.48-1.81,2.37-1.86,1.06s1.93-6.65,3.42-11.06C254.15,445.18,254,445.92,253.78,446.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.48,430.59a5.46,5.46,0,0,1,1.13-3.56l.64-.29c1.07-.54,1.54-1.1,2.12-.38l-1.16,1.32c-1.83,2.31-1.37,2.68-1.38,4a20.21,20.21,0,0,1-.82,4c-1.19,4.22-2.17,5.61-2.82,9.62s0,6.76-.54,7-1.71-.3-1.78-3.54,1.6-8.61,2.72-11.14S248.61,432.32,248.48,430.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75,451.05a.45.45,0,0,0,.2.12,9.62,9.62,0,0,1,6.28,4.06.41.41,0,0,0,.57.07.39.39,0,0,0,.07-.56,10.37,10.37,0,0,0-6.72-4.35.4.4,0,0,0-.49.29A.45.45,0,0,0,244.75,451.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41,447.71a.45.45,0,0,0,.2.12,10.79,10.79,0,0,1,6.61,4.42.41.41,0,0,0,.58.07.41.41,0,0,0,.07-.58,11.64,11.64,0,0,0-7-4.71.42.42,0,0,0-.51.29A.43.43,0,0,0,245.41,447.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,444a.45.45,0,0,0,.22.13,12.3,12.3,0,0,1,7.39,5,.47.47,0,0,0,.64.08.46.46,0,0,0,.07-.64,13.19,13.19,0,0,0-7.86-5.29.46.46,0,0,0-.46.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18,440.86a.42.42,0,0,0,.21.13,12,12,0,0,1,7.23,4.85.45.45,0,1,0,.7-.55,12.84,12.84,0,0,0-7.69-5.16.44.44,0,0,0-.55.31A.45.45,0,0,0,246.18,440.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,437.83a.38.38,0,0,0,.21.13,12,12,0,0,1,7.22,4.85.46.46,0,0,0,.63.08.45.45,0,0,0,.07-.63,12.82,12.82,0,0,0-7.68-5.16.44.44,0,0,0-.55.31A.43.43,0,0,0,247.48,437.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.82 427.53 263.9 434.75 268.51 437.94 262.65 447.93 247.72 439.96 255.82 427.53",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.73,379.26s32.76-1.95,45.8-1.29c13.32.67,13.59,10.44,10.51,16.7-7.86,16-30.18,35.34-30.18,35.34s-7.3-3.74-9.31-10.29l5.58-11.38-16.39,4.43L243,410.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.22,398.57A114.3,114.3,0,0,0,257,409.46l4.13-1.12c5.06-10.73,6.14-13.87,13.7-18.67C274.83,389.67,269.48,391.42,264.22,398.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.73,379.26l-45.38,8.31s-5.45,17.43-1.9,28,13.9,14.38,18.91,15c7.17.87,15.61-1,15.61-1a39.68,39.68,0,0,0,8.13,5.28c4.13,1.86,22.18,10.37,22.18,10.37s5.36-4.14,5.25-13.28L243,410.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.28,445.25s1-.42,2.57-3.06c-4.71-1.33-20.1-8.15-25.06-10.52-8.84-4.21-11.44-8.36-11.44-8.36s-.18,2.68,3.62,6.29a39.68,39.68,0,0,0,8.13,5.28C238.23,436.74,256.28,445.25,256.28,445.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.42,427.45c-4.53.53-16.55-2.23-20.11-10.94-3.48-8.53-1.74-18.45-.51-27l-1.47.28-4.08.32c-.51,5-1.52,17.36,1.2,25.49,3.55,10.59,13.9,14.38,18.91,15,7.17.87,15.61-1,15.61-1l-2.23-3.8A30.14,30.14,0,0,1,216.42,427.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,412.73l-2.49-3.21c-1.68-2.16-4.38-6.24-11.78-6.28s-21.64.61-21.64.61,14.91-1.87,20.06-2.5,8.53.12,11.33,2.83,7.11,7.83,7.11,7.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5,402.83a14.68,14.68,0,0,0,3.9-10.09s1.47,6.81-1.57,11.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.49,444.11c3.53,1.57,5.68,3.1,7.24,5.33s2,4.46.28,7-4.71,5.51-8.14,5.16-5.5-1.3-8.62-3.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,445.88c-.1,1.08,4.34,3.42,8.95,5.87,4.94,2.63,6.11,4.26,10.14,6.46,4.6,2.53,6.39,2.74,10.09,1.89s8.43-5.89,5.5-10.83c-2.38-4-5.65-5.26-10.62-6.81a93.48,93.48,0,0,1-11.61-4.32c-3.57-1.57-6.45-4.23-7.24-3.39.51.28,4.21,2.79,3.46,3.4-.19.32-.73.19-1.65-.24a1.6,1.6,0,0,0-1.3-.12,2.57,2.57,0,0,0-1,1.09,28.66,28.66,0,0,0-1.26,2.83c-.31.65-.18.28-.47.93a7.11,7.11,0,0,0-.89,2.54c0,.42.32.57.63.78s.75.49,1,.73c.12.1.32.42.24.57s-.77.11-1,0-.72-.26-1.05-.4S259.5,446.31,258.69,445.88Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,445.88c-.1,1.08,4.34,3.42,8.95,5.87,4.94,2.63,6.11,4.26,10.14,6.46,4.6,2.53,6.39,2.74,10.09,1.89s8.43-5.89,5.5-10.83c-2.38-4-5.65-5.26-10.62-6.81a93.48,93.48,0,0,1-11.61-4.32c-3.57-1.57-6.45-4.23-7.24-3.39.51.28,4.21,2.79,3.46,3.4-.19.32-.73.19-1.65-.24a1.6,1.6,0,0,0-1.3-.12,2.57,2.57,0,0,0-1,1.09,28.66,28.66,0,0,0-1.26,2.83c-.31.65-.18.28-.47.93a7.11,7.11,0,0,0-.89,2.54c0,.42.32.57.63.78s.75.49,1,.73c.12.1.32.42.24.57s-.77.11-1,0-.72-.26-1.05-.4S259.5,446.31,258.69,445.88Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,457.36c.66.37,4.84,2.55,6.24,1.42s-1.83-3.44-1.83-3.44-.38-3.24,3.72-7.81c.65.55,3.46.65,3.49-1s-4.58-3.89-4.65-3.92c4.76,1.5,7.89,2.75,10.2,6.67,2.93,4.94-1.81,10-5.5,10.83s-5.49.64-10.09-1.89C277.32,458,276.6,457.62,276.2,457.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,455c1.76.68.47,2.24-2.12,1.6-3.88-1-7-3.32-11.32-4.89-4.61-2.45-9.32-4.75-9-5.93.83.35,2.6,1.18,2.6,1.18.35.17,1.24.55,1.24.55,3.5,1.7,7.34,4.35,11.16,5.56C277,454.19,279.33,454.37,281.08,455Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,448.13c-1.59-1-1.84-1.84-5-3.45s-8.4-5-11.66-7.08a43.28,43.28,0,0,1-3.51-2.85c.58-.6,2.6.07,4.58,1.44s3.19,2.25,5.16,3.39c3.82,2.53,8.23,4.32,10.41,5.87S285.63,449.14,284,448.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.3,447.7a.36.36,0,0,1-.1.14,14.36,14.36,0,0,0-3.4,7.77.47.47,0,0,1-.46.42.39.39,0,0,1-.34-.47,14.93,14.93,0,0,1,3.69-8.35.37.37,0,0,1,.57,0A.46.46,0,0,1,284.3,447.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,445.26a.47.47,0,0,1-.09.12,19.58,19.58,0,0,0-4.19,9.16.46.46,0,0,1-.47.4.39.39,0,0,1-.33-.48,20.18,20.18,0,0,1,4.46-9.69.38.38,0,0,1,.57,0A.47.47,0,0,1,281.24,445.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.87,454.07a.5.5,0,0,1-.39.27.39.39,0,0,1-.37-.45c.44-5.7,4.35-10.9,4.54-11.08a.37.37,0,0,1,.57,0,.5.5,0,0,1-.06.64s-3.83,5.12-4.24,10.43A.41.41,0,0,1,273.87,454.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,452.07a.48.48,0,0,1-.39.27.4.4,0,0,1-.38-.44A16.83,16.83,0,0,1,275,441.4a.36.36,0,0,1,.56.05.49.49,0,0,1-.09.63,16.14,16.14,0,0,0-4.39,9.8A.41.41,0,0,1,271,452.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.31,450.3a.48.48,0,0,1-.38.27.38.38,0,0,1-.39-.43c.29-5.94,4.67-10.36,4.87-10.54a.38.38,0,0,1,.57,0,.48.48,0,0,1-.09.63s-4.27,4.31-4.53,9.83A.65.65,0,0,1,267.31,450.3Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.32,331.55C237.55,334,254,349.6,254,349.6c1.75-4.71,5.22-14.08,5.89-16.07,1.11-2.9,2.76-8,3.06-8.67,2-4.53,5.91-7.82,9.83-10.68.67-.5,1.35-1,2-1.46a9.83,9.83,0,0,0,1-.73c.27-.26.52-.47.94-.22a1.37,1.37,0,0,1,.55.83,4,4,0,0,1-.62,3.22,19.09,19.09,0,0,1-2.17,2.59c-.58.65.4.74.87.71,2.31-.13,5.32-2.23,7.19-3.51a30.07,30.07,0,0,1,3.66-2.57,4.55,4.55,0,0,1,2.68-.48c.62.1,1.16.4,1,1.16a3.34,3.34,0,0,1-.82,1.2,3.37,3.37,0,0,0-1.2,2.5,7.48,7.48,0,0,1,.07,2,23.09,23.09,0,0,1-1.07,2.32,20.44,20.44,0,0,0-.18,2.18,6.28,6.28,0,0,1-1.47,2.17,19.9,19.9,0,0,1-4,3.62,22.16,22.16,0,0,1-5.36,3c-1.38.59-3.58.49-4.6,2.78s-1.22,4.72-2.39,13.6c-.87,6.6-1.48,12.11-7.27,19.91-2.31,3.1-6.25,2.27-10.13-.83L231,351.84c-6.78-8.79-7.68-14.91-7.56-22.83C223.4,329,230.08,328.37,234.32,331.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,349.6c-1.69,4.07-2.72,9.86-1.18,13.51-3.27-4.64-2.1-11-.48-15.09Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,328.53a16.57,16.57,0,0,1,10,2.2,26,26,0,0,1,4.41,3.71s3.07,15.75-4.25,19.8l-7.77-4.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,324.22a2.54,2.54,0,0,0-1.57-.27,9,9,0,0,0-1.47.19,7.79,7.79,0,0,0-2.74,1.17,6,6,0,0,0-1.89,2.09,3.8,3.8,0,0,0-.46,1.24,3.89,3.89,0,0,0,.17,1.51c0,.08.15.17.18,0a3.23,3.23,0,0,1,.24-.58c.09-.23.19-.45.28-.68a6.59,6.59,0,0,1,.52-1.07A6,6,0,0,1,270,326a7.8,7.8,0,0,1,2.56-1.09,8.68,8.68,0,0,1,1.24-.21l.85-.1c.16,0,.29,0,.36-.18A.16.16,0,0,0,275,324.22Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.52,370.94l2.21,8.32s-2.65,8.35-18.75,11.26a83.76,83.76,0,0,1-29.46,0L191,379Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,360.82c1.11-16.27,2-19.48,5-23.89,3.6-1.55,9.79-4,13.7-5.35,6.79-2.32,17-3.05,17-3.05,3.49,3.35,12.17,11.19,15.15,18,2,4.53,2.49,11.55-1.6,15.6a60.93,60.93,0,0,0,1.54,11s-.68,8.59-14.94,12.45c-15.3,4.14-36-1.49-36-1.49S186.5,376.94,187.61,360.82Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,360.82c1.11-16.27,2-19.48,5-23.89,3.6-1.55,9.79-4,13.7-5.35,6.79-2.32,17-3.05,17-3.05,3.49,3.35,12.17,11.19,15.15,18,2,4.53,2.49,11.55-1.6,15.6a60.93,60.93,0,0,0,1.54,11s-.68,8.59-14.94,12.45c-15.3,4.14-36-1.49-36-1.49S186.5,376.94,187.61,360.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.92,365.54s-3.85,5.18-12,4.62c-8.37-.59-10.28-7.42-10.28-7.42s0,9.05,10,9.76A12,12,0,0,0,225.92,365.54Z",
    style: {
      fill: "#047D95",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217,406.86v.9a2.56,2.56,0,0,0,1.26,2.2l24.22,13.93a2.54,2.54,0,0,0,2.54,0l44.42-25.64a2.57,2.57,0,0,0,1.27-2.2v-.62l-47,27.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,395.43l-26.34-15.21a1.51,1.51,0,0,0-1.51,0l-45.7,26.39a.34.34,0,0,0,0,.58l26.59,15.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.51 420.3 229.3 412.11 270.84 388.13 285.12 396.28 243.51 420.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.53 397.51 236.79 397.66 243.75 401.68 256.13 394.53 256.39 394.39 249.16 390.22 236.53 397.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.79 397.66 243.75 401.68 256.13 394.53 249.16 390.51 236.79 397.66",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.75,422.54v1.69a2.49,2.49,0,0,0,1.27-.34l44.42-25.64a2.57,2.57,0,0,0,1.27-2.2v-.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.75,422.54v1.69a2.49,2.49,0,0,0,1.27-.34l44.42-25.64a2.57,2.57,0,0,0,1.27-2.2v-.62Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.47,422.91a3,3,0,0,0,2.59-.2l44.22-25.53a3,3,0,0,0,1.46-2.1l4.84-28.87a2.81,2.81,0,0,0,0-.5,3.06,3.06,0,0,0-.88-2.14l-46,26.54a2.22,2.22,0,0,0-1.08,1.56Z",
    style: {
      fill: "#047D95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.47,422.91a3,3,0,0,0,2.59-.2l44.22-25.53a3,3,0,0,0,1.46-2.1l4.84-28.87a2.81,2.81,0,0,0,0-.5,3.06,3.06,0,0,0-.88-2.14l-46,26.54a2.22,2.22,0,0,0-1.08,1.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.75,422.54l.3.17a2.3,2.3,0,0,0,.42.2l5.23-31.24a2.22,2.22,0,0,1,1.08-1.56l46-26.54a3.22,3.22,0,0,0-.62-.46l-46.05,26.58a2.27,2.27,0,0,0-1.08,1.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.37,396.26c.33-1.93,2.32-4.5,4.46-5.73s3.61-.67,3.28,1.26-2.32,4.5-4.45,5.74S269.05,398.19,269.37,396.26Z",
    style: {
      fill: "#047D95"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.26,377.33a261.78,261.78,0,0,1,4.36-28.8c1-4.93,3.28-8.54,10-11,6.66,4,5.69,17,5.06,20.37l-3.09,18.78s5.59,3.73,11.78,7.31,10.59,5.28,16.38,5.49,6.93.14,10,1.2c1.65.56,5.41,1.87,6.7,2.39s3.68,2.59,5.86,3.93-.29,2.43-1.82,2.11a19.46,19.46,0,0,1-4.68-1.81,26,26,0,0,0-4-1.17,23,23,0,0,1,1.19,4.45c.07.82.33,1.8-.34,2.47a6.35,6.35,0,0,1-1.66.85,1.25,1.25,0,0,1-.28.82,2.12,2.12,0,0,1-1.43.5,6.18,6.18,0,0,1-.85-.06,1.53,1.53,0,0,1-.83,1.26,6.68,6.68,0,0,1-3.51.41c-.17-.06-1.54-.65-1.94-.82a3.59,3.59,0,0,1-1.36-.71c-.32-.41.4-1.46,1.07-1.62a6.87,6.87,0,0,1,2.25,0,7.45,7.45,0,0,1-.81-1.87c-.69-.93-5,.42-9,.06-3-.27-5.35-2.9-6.73-3.39-8.8-3.13-16.89-4.48-25.89-9C176.55,385.43,177.7,383.46,178.26,377.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.63,396.37c-.54-1.08-1.34-2.35-2.22-2.59a10,10,0,0,1,1.44,2.38Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,403.93a9.48,9.48,0,0,0-.12-2.44,24,24,0,0,0-.51-2.38,10.36,10.36,0,0,0-.85-2.31,4.53,4.53,0,0,0-1.62-1.82,3.37,3.37,0,0,1,.75.93,6.94,6.94,0,0,1,.54,1,16.71,16.71,0,0,1,.73,2.27c.21.77.4,1.55.6,2.33A20.72,20.72,0,0,1,234,403.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.48,405.19a11.29,11.29,0,0,0-.19-2.39,20.74,20.74,0,0,0-.55-2.33,18.48,18.48,0,0,0-.84-2.25,4.58,4.58,0,0,0-1.39-1.94,2.85,2.85,0,0,1,.62,1c.16.35.31.72.44,1.09.26.74.5,1.49.72,2.24C230.74,402.12,231.16,403.63,231.48,405.19Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,403.71a3.62,3.62,0,0,1,1,.06c.32,0,.56.19,1,.28l-.18-.24a1,1,0,0,0,.1.46,1.14,1.14,0,0,0,.26.35,1.4,1.4,0,0,0,.7.39,3.65,3.65,0,0,1-.45-.58,2,2,0,0,1-.13-.31,1.48,1.48,0,0,1,0-.27v-.18l-.19-.06a2.71,2.71,0,0,0-.95-.12A2,2,0,0,0,224.91,403.71Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.57,312.28l-.59-2.66c4.75-3.66,4.19-9.69,2.34-13-4.14-7.44-12.92-8.37-18.67-7.27-8.11,1.55-12.8,5.19-13,10.56-1.38.11-3.52,2.29-4.11,4.13-3.33,10.53,8.89,16.85,12.65,23.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.09,286.71l-.19.05a3.55,3.55,0,0,0-2.83,3.22,3.85,3.85,0,0,0-4.15,5.82.62.62,0,0,1,.14.38.48.48,0,0,1-.29.33,2.23,2.23,0,0,1-2.82-.71,2.06,2.06,0,0,0,.58,2.3,4,4,0,0,0,2.34.89,2.84,2.84,0,0,0-1.37,3,4,4,0,0,0,2.17,2.67,2,2,0,0,1,1-2.38,2.69,2.69,0,0,0,4.16,3.11c-.24,1,.76,1.9,1.73,2.29a4.4,4.4,0,0,0,2.23.33,2.39,2.39,0,0,0,1.81-1.25,2.76,2.76,0,0,0,1.39.35c.72-.08,1.75-2.26,1.75-2.26,1.75.19,3.7.32,5-.8a4.4,4.4,0,0,0,1.43-2.83,13.44,13.44,0,0,0-.07-3.23,3,3,0,0,0,2.43-3.67,3.69,3.69,0,0,0-3.92-2.47,3.06,3.06,0,0,0-1.26-3.8,6.82,6.82,0,0,0-4.25-.77c-1,.07-2.07.35-2.41,1.24A4.55,4.55,0,0,0,190.09,286.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.31,323.11a5,5,0,0,1-4.67-2.49c-2.1-3-2.21-5.11-1.11-7,.89-1.54,3.19-2.57,4.85-1.6s1.86,1.93,2.55,3.14,2.15,1.57,2.61-3.42c.43-4.67-.12-9.49,2.09-11.66,3.3-3.23,7.76-2.5,9.17-.69a4.18,4.18,0,0,1,5.85-1.76,8.85,8.85,0,0,1,4.52,5,7.79,7.79,0,0,1,.12,2.71,9.14,9.14,0,0,0,.56,3.91c1.38,3.76,1.79,11.19-.94,15.2-1.5,2.19-4.18,2.95-7.55,3.21l.45,4.56s4.19,3.91,4.41,11.61a29.92,29.92,0,0,1-12.48-3.26c-5.49-2.69-7-6.29-7-6.29l-1.11-12.86S201.55,322.82,199.31,323.11Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,305.57l-3.44-.87a1.71,1.71,0,0,1,2.1-1.32A1.87,1.87,0,0,1,224,305.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,308.48A1.42,1.42,0,1,1,222,307.2,1.43,1.43,0,0,1,223.58,308.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.06,309.7a1.42,1.42,0,1,1-1.54-1.28A1.42,1.42,0,0,1,214.06,309.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18,305.88l-3.35,1.78a1.82,1.82,0,0,1,.71-2.54A2,2,0,0,1,212.18,305.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,300.64c-.73,1.07-1.24,2.12-.87,5.72.16,1.5.29,5-.58,7.18-.75,1.89-1.59,3-3.52,3.52A7.19,7.19,0,0,1,198,317c-.71-.27-2.75-1.51-2.65-3.53a4.12,4.12,0,0,0,1.49.9,3.61,3.61,0,0,0,4.51-1.85c1.17-2,.9-4.64,1.15-6.9.31-2.87.58-6.11,3-7.69,2.9-1.87,8.41-1.51,9.28,1.53A6,6,0,0,0,206.49,300.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.27,317.34l5,1.17a2.58,2.58,0,0,1-3.33,1.85A2.42,2.42,0,0,1,214.27,317.34Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36,320.39a2.69,2.69,0,0,0-2.89-2.17l-.25,0a2.28,2.28,0,0,0,1.73,2.09A2.94,2.94,0,0,0,217.36,320.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.74 306.82 218.87 315.68 223.21 313.03 216.74 306.82",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.36,327.68a17.9,17.9,0,0,1-9.48-2.12,13.5,13.5,0,0,1-4.91-5s.71,4.34,4,6.58c4.43,3,10.53,2.31,10.53,2.31Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,337c-5.94,2.08-8.61,3.45-10.27,12.62,12.14,1.89,15,10.5,15,10.5s.52-2.52,1.21-6.51S198.29,339.85,192.57,337Z",
    style: {
      fill: "#455a64"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.13595ada1d72dda055247198e8fc884d.svg";
export { ForwardRef as ReactComponent };